import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import Select from 'react-select';
import load from "../../assets/Images/loader.gif";
import * as api from "../../api_function";
// import BusinessOppotunitySurveyForm from './BusinessOppotunitySurveyForm';
import * as wifiOptions from "../../options_sets/WifiOptions"
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import { cache } from 'react';
import { Link } from 'react-router-dom';


const optionLost = [
  // { name: "Disqualify", code: "" },
  { name: "Select reason for cancellation", code: "569480018" },
  { name: "Required Solution not Available", code: "569480017" },
  { name: "Customer Found Our Product Costly", code: "569480006 " },
  { name: "Location Is Non-RFS", code: "569480007" },
  { name: "Customer Looking For Promotional Offers", code: "569480008 " },
  { name: "Customer Wanted Information Only", code: "569480009" },
  { name: "Existing Customer", code: "569480010" },
  { name: "Customer Do Not Have Required Documents", code: "569480011" },
  { name: "Customer Is defaulter", code: "569480012 " },
  { name: "Duplicate Lead", code: "569480000 " },
  { name: "Incorrect Demographic Details", code: "569480001" },
  { name: "Broadband-Home User", code: "569480002" },
  { name: "Customer Not Interested", code: "569480003" },
  { name: "Customer Moved To Other Service Provider", code: "569480004" },
  { name: "Delay in Response", code: "569480005" },
  { name: "Canceled", code: "4" },
  { name: "Out-Sold", code: "5" },
];


const password = sessionStorage.getItem('password');
const userName = sessionStorage.getItem('userName');

const optionSolutation = [
  { label: "Select Salutation", value: "0" },
  { label: "Mr.", value: "1" },
  { label: "Mrs.", value: "2" },
  { label: "Miss", value: "3" },
];

const optionTurnOver = [
  { label: "Select Option", value: "0" },
  { label: "Diamond (>250Cr)", value: "111260000" },
  { label: "Emerald (100Cr-250Cr)", value: "111260001" },
  { label: "Ruby (10Cr-100Cr)", value: "111260002" },
  { label: "Bronze (1Cr-10Cr)", value: "111260003" }
]

const optionCountry = [{ label: "India", value: "10001" }];

const optionState = [
  { name: "Select State", code: "" },
  { name: "Andhra Pradesh", code: "100009" },
  { name: "Jharkhand", code: "100030" },
  { name: "Bihar", code: "100021" },
  { name: "Delhi", code: "100004" },
  { name: "Gujarat", code: "100015" },
  { name: "Haryana", code: "100008" },
  { name: "Jammu and Kashmir", code: "100011" },
  { name: "Karnataka", code: "100007" },
  { name: "Kerala", code: "100012" },
  { name: "Madhya Pradesh", code: "100014" },
  { name: "Maharashtra", code: "100002" },
  { name: "Odisha", code: "100026" },
  { name: "Other*", code: "100017" },
  { name: "Punjab", code: "100025" },
  { name: "Rajasthan", code: "100010" },
  { name: "Tamil Nadu", code: "100003" },
  { name: "Telangana", code: "100023" },
  { name: "Uttar Pradesh", code: "100006" },
  { name: "Uttarakhand", code: "100016" },
  { name: "West Bengal", code: "100013" },
  { name: "Goa", code: "100028" },
];

const optionCustomerSeg = [
  { label: "Select Customer Segment", value: "0" },
  { label: "SDWAN", value: "111260004" },
  { label: "SMB", value: "111260000" },
  { label: "Media", value: "111260001" },
  { label: "LA", value: "111260002" },
  { label: "SP", value: "111260003" },
];

const firmtype = [
  { value: "0", label: "Select Firm Type" },
  { value: "1", label: "Proprietorship" },
  { value: "2", label: "Partnership" },
  { value: "3", label: "Pvt Ltd" },
  { value: "4", label: "Ltd" },
  { value: "5", label: "Trust" },
  { value: "6", label: "Individual" },
  { value: "7", label: "LLP" },
];

const media = [
  { label: "Fibre", value: "1" },
  { label: "RF", value: "2" },
]

const ExServiceProvider = [
  { label: "Select Service Provider 1", value: "0" },
  { label: "Jio", value: "111260000" },
  { label: "ACT Fibernet", value: "569480014" },
  { label: "N.A", value: "569480012" },
  { label: "Others", value: "569480013" },
  { label: "Airtel", value: "569480000" },
  { label: "Aircel", value: "569480002" },
  { label: "BSNL", value: "569480003" },
  { label: "Hathway", value: "569480004" },
  { label: "MTNL", value: "569480005" },
  { label: "Nextra", value: "569480006" },
  { label: "Reliance Communications", value: "569480007" },
  { label: "Sify", value: "569480008" },
  { label: "Tata Communications", value: "569480009" },
  { label: "Tata DOCOMO", value: "569480010" },
  { label: "Tikona Infinet", value: "569480011" },
  { label: "Vodafone", value: "569480001" },
]

const optionInterestedFirewall = [
  { label: "Select Option", value: "" },
  { label: "Yes", value: "1" },
  { label: "No", value: "2" }
];

const optionInterestedVPN = [
  { label: "Select Option", value: "" },
  { label: "Yes", value: true },
  { label: "No", value: false }
];

const optionInterestedManageWiFi = [
  { label: "Select Option", value: "" },
  { label: "Yes", value: "1" },
  { label: "No", value: "2" }
];



const userTypeOption = [

  { value: "111260000", label: "Base Plan" },
  { value: "111260001", label: "User 2" },
  { value: "111260002", label: "User 3" },
  { value: "111260003", label: "User 4" },
  { value: "111260004", label: "Visitor" },
  { value: "111260005", label: "Event" },
];

const speedPerUserOption = [

  { value: "111260000", label: "Upto 5 Mbps" },
  { value: "111260001", label: "Upto 10 Mbps" },
  { value: "111260002", label: "Upto 15 Mbps" },
  { value: "111260003", label: "Upto 20 Mbps" },
  { value: "111260004", label: "Upto 30 Mbps" },
  { value: "111260005", label: "Upto 40 Mbps" },
  { value: "111260006", label: "Upto 50 Mbps" },
  { value: "111260007", label: "Upto 75 Mbps" },
  { value: "111260008", label: "Upto 100 Mbps" },
];

const planValidityOption = [

  { value: "111260000", label: "Per Day" },
  { value: "111260001", label: "Per Month" },
];

const loginMechanismOption = [
  { value: "111260000", label: "Username & Password" },
  { value: "111260001", label: "Username & Password with Additional Authentication" },
  { value: "111260002", label: "RMN & One-Time Password(OTP)" },
  { value: "111260003", label: "MAC Authentication" },
];

const qwertyOptions = [
  { label: "Select Option", value: "0" },
  { label: "Yes", value: "122050000" },
  { label: "No", value: "122050001" }
];


const BusinessOpportunityForm = () => {
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // Remove box shadow
      boxShadow: "none",
      backgroundColor: "transparent",
      color: "black",
    }),
  };

  const [verticalOptions, setVerticalOptions] = useState([]);
  const [selectedVertical, setSelectedVertical] = useState("");
  const [getSiteDetailsData, setSiteDetailsData] = useState([]);

  const [userType, setUserType] = useState("");
  const [speedPerUser, setSpeedPerUser] = useState("");
  const [planValidity, setPlanValidity] = useState("");
  const [loginMechanism, setLoginMechanism] = useState("");

  const [activeForm, setActiveForm] = useState("form1");
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedRelatedProduct, setSelectedRelatedProduct] = useState("");
  const [discountFlag, setDiscountFlag] = useState();
  const [getExOtcDiscount, setExOtcDiscount] = useState("NA");
  const [getExRcDiscount, setExRcDiscount] = useState("NA");
  const [productOptions, setProductOptions] = useState([]);
  const [relatedProductOptions, setRelatedProductOptions] = useState([]);
  const [getOTCProd, setOTCProd] = useState([]);
  const [getRCProd, setRCProd] = useState([]);
  const [selectedPriceList, setSelectedPriceList] = useState("");
  const [priceListOptions, setPriceListOptions] = useState([]);
  const [leadid, setleadid] = useState("");
  const [industrydropdetails, setindustrydropdetails] = useState([]);
  const [selectSociety, setSelectSociety] = useState("");
  const [selectedFirmType, setSelectedFirmType] = useState();
  const [selectIndustry, setSelectIndustry] = useState();
  const [selectedCompany, setSelectedCompany] = useState();
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [enableGenerateFeasibilityBtn, setEnableGenerateFeasibilityBtn] = useState(false);
  const [isRedundancyLocked, setIsRedundancyLocked] = useState(false);
  const [selectGroup, setSelectGroup] = useState("");
  const [selectRelationship, setSelectRelationship] = useState({});
  const [loader, setLoader] = useState(false);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [getOtcDiscount, setOtcDiscount] = useState([]);
  const [getRcDiscount, setRcDiscount] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);
  const [relationshipOptions, setRelationOptions] = useState([]);
  const [selectSolutaton, setSelectSolutaton] = useState(optionSolutation[0]);
  const [statusCode, setStatusCode] = useState("")
  const [status, setStatus] = useState("")
  const [selectCountry, setSelectCountry] = useState("");
  const [selectState, setSelectState] = useState("");
  const [selectCity, setSelectCity] = useState("");
  const [cityType, setCityType] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [selectArea, setSelectArea] = useState("");
  const [buildingList, setBuildingList] = useState([]);
  const [selectBuilding, setSelectBuilding] = useState("");
  const [selectCustomerSeg, setSelectCustomerSeg] = useState(optionCustomerSeg[0]);
  const [selectTurnOver, setSelectTurnOver] = useState(optionTurnOver[0]);
  const [selectedMedia, setSelectedMedia] = useState(optionTurnOver[0]);
  const [selectExServiceProvider1, setSelectExServiceProvider1] = useState();
  const [selectInterestedFirewall, setSelectInterestedFirewall] = useState('');
  const [selectInterestedVPN, setSelectInteretedVPN] = useState();
  const [selectInterestedManageWiFi, setSelectInterestedManageWiFi] = useState('');
  const [otcAmount, setOtcAmount] = useState("")
  const [rcAmount, setRcAmount] = useState("")
  const [sdAmount, setSdAmount] = useState("")
  const [otcAmountDis, setOtcAmountDis] = useState("")
  const [rcAmountDis, setRcAmountDis] = useState("")
  const [getDoaApprovalData, setDoaApprovalData] = useState([]);
  const [getDoaApprovedFlag, setDoaApprovedFlag] = useState(false);
  const [getFeasibilityApprovedFlag, setFeasibilityApprovedFlag] = useState(false);
  const [getSurveyApprovedFlag, setSurveyApprovedFlag] = useState(true);
  const [getFeasibilityData, setFeasibilityData] = useState([]);
  const [getSurveyTaskData, setSurveyTaskData] = useState([]);
  const [getPreSalesTask, setPreSalesTask] = useState([]);
  const [getSurveyTask, setSurveyTask] = useState([]);
  const [getQuoteDetail, setQuoteDetail] = useState([]);
  const [getCompanyGroupList, setCompanyGroupList] = useState([]);
  const [getUserlicencegridData, setUserlicencegridData] = useState([]);

  const [allQuoteData, setAllQuoteData] = useState([]);
  const [getIpProd, setIpProd] = useState([]);

  const [allPraposalData, setAllPraposalData] = useState([]);
  const [getOppProduct, setOppProduct] = useState("");
  const [OppSubSeg, setOppSubSeg] = useState("");


  const handleCompanyChange = (selectedOption) => {
    setSelectedCompany(selectedOption);
  };

  const handleSelectGroup = (selectGroup) => {
    setSelectGroup(selectGroup);
  };

  const handleSelectRelationship = (selectGroup) => {
    setSelectRelationship(selectGroup);
  };

  const handlePriceListChange = (selectOption) => {
    setSelectedPriceList(selectOption);
  };

  const handleSelectFirmType = (selectFirmType) => {
    setSelectedFirmType(selectFirmType);
  };

  const handleIndustryChnage = (selected) => {
    setSelectIndustry(selected);
  };

  const handleSelectSolutation = (selectSolutation) => {
    setSelectSolutaton(selectSolutation);
  };

  const handleSelectCountry = (selectOption) => {
    setSelectCountry(selectOption);
  };

  const handleSelectState = (selectOption) => {
    setSelectState(selectOption);
  };

  const handleSelectCustomerSeg = (selectCustomerSeg) => {
    setSelectCustomerSeg(selectCustomerSeg);
  };

  const handleSelectTurnOver = (selectTurnOver) => {
    setSelectTurnOver(selectTurnOver);
  };

  const handleSelectMedia = (selectMedia) => {
    setSelectedMedia(selectMedia);
  };

  const handleSelectServiceProvider1 = (exServiceProvider) => {
    setSelectExServiceProvider1(exServiceProvider);
  };

  const handleInterestedFirewall = (firewall) => {
    setSelectInterestedFirewall(firewall);
  }

  const handleInterestedVPN = (value) => {
    // console.log(value);

    setSelectInteretedVPN(value);
  }

  const handleInterestedManageWiFi = (value) => {
    setSelectInterestedManageWiFi(value);
  }

  const yyyymmddFormat = (dateStr) => {
    if (!dateStr) return "";
    const parts = dateStr.split("-");
    if (parts.length !== 3) return "";
    if (parts[0].length === 4) {
      return dateStr; // Already in YYYY-MM-DD format
    } else {
      // Convert from DD-MM-YYYY to YYYY-MM-DD
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
  };

  const [currentWorkLocations, setCurrentWorkLocations] = useState([]);
  const [selectCurrentWorkLocation, setSelectCurrentWorkLocation] =
    useState("");
  const handleCurrentWorkLocation = (currentWorkLocation) => {
    // console.log(currentWorkLocation);

    setSelectCurrentWorkLocation(currentWorkLocation);
  };

  const [minPoNext, setMinPoNext] = useState();
  const [opportunityDataWifi, setOpportunityDataWifi] = useState({})
  const [SdwanOpp, setSdwanOpp] = useState({
    NoOfLocation: "",
    CustomerILLservices: "",
    NumberOfLinksIll: "",
    CustomerBroadbandServices: "",
    NumberOfLinksBroadbandServices: "",
    LinksManagedLinks: "",
    CustomerRoutingServices: "", // default to "No" value if needed
    FirewallSetToExpire: "",
    itSupport: "",
    linksManagedLinks: "",
    IndicationITSpent: "",
    CurrentOperationalCity: "",
    NetworkSecurityServices: "",
    ApplicationsHosted: "",
    ItSupport: "",
    RedundancyMPLS: "",
    MPLSBackbone: "",
    MPLSContract: "",
    SdwanRemarks: ""
  });
  const [opportunityData, setOpportunityData] = useState({
    NoofUsers: "",
    userType: "",
    noUserLicences: "",
    speedPerUser: "",
    planValidity: "",
    dataValume: "",
    devicesPerUser: "",
    loginMechanism: "",
    Remarks: "",
    Redunancy: false,
    Block: "",
    Status: "",
    Statuscode: "",
    OppId: "",
    OppStatus: "",
    LeadId: "",
    PriceList: "",
    Topic: "",
    StateId: "",
    CityId: "",
    AreaId: "",
    BuildingId: "",
    SpecificArea: "",
    SpecificBuilding: "",
    Building_BuildingStatus: "",
    NoOfUsers: "",
    NoOfBeds: "",
    IndustryId: "",
    ApprovalRequiredFlag: "",
    Reason: "",
    Area: "",
    Subbusinesssegment: "",
    Businesssegment: "",
    State: "",
    Salutation: "",
    Relationship: "",
    PostalCode: "",
    Mobilephone: "",
    Media: "",
    Lco: null,
    Industry: "",
    Group: "",
    Floor: "",
    TPFeasibilty: "",
    CreateAreaOrBuilding: false,
    Firmtype: "",
    Product: "",
    ProductSegment: "",
    FeasibilityRequired: false,
    Existingprovider: "",
    Emailaddress: "",
    Country: "",
    Companyname: "",
    City: "",
    leadname: "",
    Buildingname: "",
    BuildingNo: "",
    ContactPerson: "",
    CustomerSegment: "",
    LastMileType: "",
    UpTimesla: "",
    Firewall: "",
    CompanySelf: "",
    PoLock: "",
    Price: "",
    OriginatingLead: "",
    FirewallAwc: "",
    PoNext: "",
    Company: "",
    TotalAmount: "",
    VerticalID: "",
    TypeOfOrder: "",
    PocClosureDate: "",
    TurnOver: "",
    SocietyName: "",
    SocietyId: "",
    SocietyStatus: "",
    HousePlotFlatNo: "",
    BlockTowerNumber: "",
    OTCAmount: "",
    SDAmount: "",
    RCAmount: "",
    sdDiscount: "",
    rcDiscount: "",
    otcDiscount: "",
    exOtcDiscount: "",
    exSdDiscount: "",
    exRcDiscount: "",
    ipDiscount: "",

  });
  const modalRef = useRef(null);

  useEffect(() => {
    const modalElement = modalRef.current;
    if (modalElement) {
      const handleShowModal = (event) => {
        // Button that triggered the modal
        const button = event.relatedTarget;
        // Extract info from data-bs-* attributes
        const recipient = button.getAttribute('data-bs-whatever');
        // Update the modal's content.
        const modalTitle = modalElement.querySelector('.modal-title');
        const modalBodyInput = modalElement.querySelector('.modal-body input');

        if (modalTitle) {
          modalTitle.textContent = 'New message to ' + recipient;
        }
        if (modalBodyInput) {
          modalBodyInput.value = recipient;
        }
      };

      modalElement.addEventListener('show.bs.modal', handleShowModal);

      // Cleanup the event listener when the component unmounts
      return () => {
        modalElement.removeEventListener('show.bs.modal', handleShowModal);
      };
    }
  }, []);
  const handleChange = (e) => {
    const { name, value, type } = e.target;

    // console.log(name, value);

    setOpportunityData((prevData) => ({
      ...prevData,
      [name]: type === "number" ? String(value) : value,
    }));

    if (name == "PoLock") {
      let minPoNext = new Date(new Date(value).setFullYear(new Date(value).getFullYear() + 1)).toISOString().split("T")[0]
      setMinPoNext(minPoNext)
      // console.log(PoNext); 
    }
  };



  const discountInput = async (e) => {
    const { name, value, type } = e.target;
    // console.log(name, value, getOTCProd[0], getRCProd[0]);

    // if(!selectedRelatedProduct?.value){
    //   toast.error("Select related product");
    //   return
    // }

    if (name == 'ipDiscount' && getIpProd?.length > 0) {
      if (opportunityData?.ipDiscount > getIpProd[0].PricePerUnit) {
        toast.warning("IP Discount should not be greater tha configured amount")
        return;
      }
      let req = { oppid: OppId, productid: getIpProd[0].ProductId, discount: opportunityData?.ipDiscount };
      const result = await api.updateOppProduct(req);

    } else if (name == 'otcDiscount' && getOTCProd?.length > 0) {

      let req = { oppid: OppId, productid: getOTCProd[0].ProductId, discount: opportunityData.otcDiscount };
      const result = await api.updateOppProduct(req);
      // console.log(result);

    } else if (name == 'rcDiscount' && getRCProd?.length > 0) {

      let req = { oppid: OppId, productid: getRCProd[0].ProductId, discount: opportunityData.rcDiscount };
      const result = await api.updateOppProduct(req);
      // console.log(result);

    } else if (name == 'OTCAmount') {
      if (otcAmount > (type === "number" ? String(value) : value)) {
        toast.warning("OTC Amount can't be less than the existing amount.");
        return;
      }
      // console.log(opportunityData.OTCAmount);

      let req = { oppid: OppId, productid: getOTCProd[0].ProductId, priceperunit: opportunityData.OTCAmount, pricing: "Override Price" };
      const result = await api.updateOppProduct(req);
      // console.log(result);

    } else if (name == 'RCAmount') {
      if (rcAmount > (type === "number" ? String(value) : value)) {
        toast.warning("RC Amount can't be less than the existing amount.");
        return;
      }

      let req = { oppid: OppId, productid: getRCProd[0].ProductId, priceperunit: opportunityData.RCAmount, pricing: "Override Price" };
      const result = await api.updateOppProduct(req);
      // console.log(result);

    }

  };


  const manageDocClickBusiness = () => {
    navigate(`/businessCAFmangeNewDoc?OppId=${OppId}`);
    // BusinessSAFmanageFormDOC() ;
  };


  const handleCreateCaf = () => {
    // console.log("leadid", leadid);
    navigate(`/businessCAFmanageForm?OppId=${OppId}&LeadId=${leadid}`)
  };

  const handleCreateSaf = () => {
    // console.log("leadid", leadid);
    navigate(`/businessSAFmanageForm?OppId=${OppId}&LeadId=${leadid}`)
  };



  const generateFeasibility = async (opp) => {
    const genfeas = await api.generateFeasibility(opp);
    // console.log(genfeas);
    if (genfeas?.Status == "Success") {
      toast.success(genfeas.Response.Message, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      })
      setTimeout(() => {
        window.location.reload()
      }, 1500);
    } else {
      toast.error("Feasibility Not Generated.")
    }
  };

  const createSurveyTask = async (opp) => {
    const genfeas = await api.createSurveyTask(opp);
    // console.log(genfeas);
    if (genfeas?.Status == "Success") {
      toast.success(genfeas.Response.Message)
      setTimeout(() => {
        window.location.reload()
      }, 1500);
    } else if ((genfeas.Response.Message).includes("Survey Task already generated")) {
      toast.warning("Survey Task already generated")
    } else {
      toast.error("Survey Task already generated")
    }
  };




  const handleIconClick = (formId) => {
    // if (activeForm !== formId) {
    //   setActiveForm(formId);
    // }

    setActiveForm((prevActiveBox) =>
      prevActiveBox === formId ? null : formId
    );
  };
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const OppId = searchParams.get("OppId");
  const CafId = searchParams.get("CafId");
  const navigate = useNavigate();
  // const redirectLeadPage = () => {
  //   navigate("/businessLead");
  // };

  const redirectPriceCalPage = () => {
    navigate(`/priceCalculator?OppId=${OppId}`);
  }




  useEffect(() => {
    const fetchGetQuotation = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
          "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          "Action": "getQuotation",
          "OppId": OppId ? OppId : "",
          "password": sessionStorage.getItem('password'),
          "userName": sessionStorage.getItem('userName')
        }

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        const result = await response.json();

        // console.log("API Response getQuotation:", result.Response.Data);
        setAllQuoteData(result?.Response?.Data)


      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGetQuotation();
  }, []);

  useEffect(() => {
    const fetchGetPraposal = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
          "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          "Action": "getProposalList",
          "OpportunityID": OppId ? OppId : "",
          "password": sessionStorage.getItem('password'),
          "userName": sessionStorage.getItem('userName')
        }

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        const result = await response.json();

        // console.log("API Response fetchGetPraposal:", result.Response.Data);
        setAllPraposalData(result?.Response?.Data)


      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGetPraposal();
  }, []);

  // Function to convert a base64 string to a Blob
  const base64ToBlob = (base64, mime) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mime });
  };

  const handleDownload = (data) => {
    // Ensure there is a base64 string available
    const base64String = data.ProposalFileContent;
    if (!base64String) {
      console.error("No base64 data available for download.");
      return;
    }

    // Set the file name and MIME type (adjust if needed)
    const fileName = data.ProposalDocName || "downloaded_document.pdf";
    const mimeType = "application/pdf"; // Change if your document type is different

    // Convert base64 string to a Blob object
    const blob = base64ToBlob(base64String, mimeType);

    // Create a URL for the Blob object
    const blobUrl = URL.createObjectURL(blob);

    // Create a temporary anchor element to trigger the download
    const downloadLink = document.createElement("a");
    downloadLink.href = blobUrl;
    downloadLink.download = fileName;

    // Append the link to the body (required for Firefox)
    document.body.appendChild(downloadLink);
    downloadLink.click();

    // Clean up and remove the temporary link
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(blobUrl);
  };




  const handleAddQuote = async () => {
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;

      const requestData = {
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "Action": "addQuotation",
        "OppId": OppId ? OppId : "",
        "password": sessionStorage.getItem('password'),
        "userName": sessionStorage.getItem('userName')
      }
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const result = await response.json();
      if (result?.Response?.StatusCode == 200) {
        toast.success(result?.Response?.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        window.location.reload()
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      setLoading(false);
    }
  }


  const handleWonQoute = async (quoteId) => {
    try {
      // setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData =
      {
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "Action": "updateQuote",
        "QuoteID": quoteId,
        "Status": "Won",
        "password": sessionStorage.getItem('password'),
        "userName": sessionStorage.getItem('userName'),
        "CreateRevisedQuote": "Yes"
      }

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const result = await response.json();
      if (result?.Response?.StatusCode == 200) {
        toast.success(result?.Response?.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        // window.location.reload()
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      // setLoading(false);
    }
  }

  const handleLostQoute = async (quoteId) => {
    try {
      // setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;

      const requestData = {
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "Action": "updateQuote",
        "QuoteID": quoteId,
        "Status": "Lost",
        "password": sessionStorage.getItem('password'),
        "userName": sessionStorage.getItem('userName'),
        "CreateRevisedQuote": "Yes"
      }
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const result = await response.json();
      if (result?.Response?.StatusCode == 200) {
        toast.success(result?.Response?.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        // window.location.reload()
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      // setLoading(false);
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      const feasibilityData = await api.getFeasibility(OppId);
      const getAllSiteDetailsData = await api.getAllSiteDetails(OppId);
      const preSalesData = await api.getPreTask(OppId);
      const quoteData = await api.getQuote(OppId);
      const getApprovalData = await api.getApproval(OppId);

      // console.log("getApprovalData",getApprovalData.Response);
      // console.log(quoteData?.Response);
      // console.log(preSalesData);

      // const allDoaApproved = getApprovalData?.Response?.Data?.every(approval => approval.StatusReason === "Approved"  && approval.Status == "Active");
      const allActiveDoa = getApprovalData?.Response?.Data?.filter(approval => approval?.Status == "Active");
      const allDoaApproved = allActiveDoa?.every(approval => approval?.StatusReason == "Approved");
     
      

      const allFeasibilityApproved = feasibilityData?.Response?.Data?.every(approval => approval.FeasibilityStatus == "1");
      getAllSiteDetailsData?.Response?.Data?.length > 0 && setSiteDetailsData(getAllSiteDetailsData?.Response?.Data)

      console.log("allFeasibilityApproved",allFeasibilityApproved);
      

      allDoaApproved !== undefined && setDoaApprovedFlag(allDoaApproved);
      allDoaApproved == undefined && setDoaApprovedFlag(true);
      allFeasibilityApproved !== undefined && setFeasibilityApprovedFlag(allFeasibilityApproved);
      allFeasibilityApproved == undefined && setFeasibilityApprovedFlag(true);

      // getApprovalData?.Response?.Data?.length > 0 && setDoaApprovalData(getApprovalData?.Response?.Data)
      const activeApproval = getApprovalData?.Response?.Data?.filter(approval => approval.Status == "Active")
      const sortedApproval = activeApproval?.sort((a, b) => parseInt(a.Name.split(" ")[0]) - parseInt(b.Name.split(" ")[0]));
      sortedApproval?.length > 0 && setDoaApprovalData(sortedApproval)

      feasibilityData?.Response?.Data?.length > 0 && setFeasibilityData(feasibilityData?.Response?.Data)
      preSalesData?.Response?.Data?.length > 0 && setPreSalesTask(preSalesData?.Response?.Data)
      setQuoteDetail(quoteData?.Response?.Data)
      // const approvalData = await getApproval();
      // setFeasibilityData(feasibilityData.Response.Data)
      // const generateFeasibilityRes = await generateFeasibility();

      // console.log(feasibilityData?.Response?.Data);

      const getSurveyTaskData = await api.getSurveyTask(OppId);
      const userlicencegrid = await api.getUserlicencegrid(OppId);
      // console.log(userlicencegrid);
      // console.log([getSurveyTaskData?.Response]);
      const allSurveyApproved = getSurveyTaskData?.Response?.Data?.every(approval => approval.Status === "Approved");
      allSurveyApproved !== undefined && setSurveyApprovedFlag(allSurveyApproved);
      [getSurveyTaskData?.Response].length > 0 && setSurveyTaskData([getSurveyTaskData?.Response])


      if (userlicencegrid?.Status == "Success") {
        setUserlicencegridData(userlicencegrid?.Response?.userlicense)
      }
    };

    fetchData();
    // generateFeasibility();
    // createApproval();
    // createQuote();
    // Cleanup function not needed in this case
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestBody = {
          Action: "getopportunity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          LeadId: "",
          OppId: OppId ? OppId : "",
          password: sessionStorage.getItem('password'),
          userName: sessionStorage.getItem('userName'),
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responsedata = await response.json();
        const responseData = responsedata?.Response?.Data?.[0];
        // console.log(responseData?.ProductSegment, responseData?.Building_BuildingStatus, responseData?.Redunancy, responseData?.InfraFlag);

        const CityRequestBody = {
          Action: "getCity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
          stateCode: "0",
        };
        const CityResponse = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(CityRequestBody),
        });
        const CityData = await CityResponse.json();

        // Transform city data into options for react-select
        let cityOptions = [];
        if (CityData?.Response?.Data) {
          cityOptions = CityData.Response.Data.map((city) => ({
            label: city.CityName,
            value: city.CityCode,
          }));
          setCurrentWorkLocations(cityOptions);
        }

        // --- Set Default City Selection ---
        // Retrieve the operational city values from opportunity data
        const sdwanOpp = responseData?.sdwanOpp || {};
        const cityID = sdwanOpp?.CurrentOperationalCityID;
        // Use the provided city name if available
        let cityLabel = sdwanOpp?.CurrentOperationalCity;

        // If cityLabel is missing, try to find it in the cityOptions array
        if (!cityLabel && cityOptions.length > 0) {
          const matchedCity = cityOptions.find((city) => city.value === cityID);
          cityLabel = matchedCity ? matchedCity.label : "Select City";
        }

        // Set the default selected city for the Select component
        setSelectCurrentWorkLocation({ value: cityID, label: cityLabel });

        // console.log("getLeads1" ,responsedata1);
        if (responsedata?.Status === "Success" && responseData) {
          setOppSubSeg(responseData.Subbusinesssegment);
          setSdwanOpp(responseData.sdwanOpp);
          const verticalId = responsedata?.Response?.Data?.[0].VerticalID || "";

          // Find matching option from verticalOptions
          const selectedVerticalOption = verticalOptions.find(option => option.value === verticalId);
          // console.log("selectedVerticalOption", selectedVerticalOption);


          // Update state
          setSelectedVertical(selectedVerticalOption);

          setOppProduct(responseData.Product)
          if ((responseData?.ProductSegment == "BIA" || responseData?.ProductSegment == "Internet Leased Line (ILL)") && responseData?.Building_BuildingStatus == "Non-RFS") {
            setEnableGenerateFeasibilityBtn(true)
            setIsRedundancyLocked(false)
          }
          if ((responseData?.ProductSegment == "BIA" || responseData?.ProductSegment == "Internet Leased Line (ILL)") && responseData?.Building_BuildingStatus !== "Non-RFS") {
            setEnableGenerateFeasibilityBtn(false)
            setIsRedundancyLocked(true)
          }
          if ((responseData?.ProductSegment == "DIA" || responseData?.ProductSegment == "Secured Managed Internet" || responseData?.ProductSegment == "Managed Office Solution") && responseData?.Redunancy == true) {
            setEnableGenerateFeasibilityBtn(true)
            setIsRedundancyLocked(true)
          }
          if (responseData?.ProductSegment == "Managed Wi-Fi Business" && responseData?.InfraFlag !== 'YES' && responseData?.Redunancy == true) {
            setEnableGenerateFeasibilityBtn(true)
            setIsRedundancyLocked(false)
          }
          if (responseData?.ProductSegment == "Managed Wi-Fi Business" && responseData?.InfraFlag == 'YES' && responseData?.Redunancy == true) {
            setEnableGenerateFeasibilityBtn(false)
            setIsRedundancyLocked(true)
          }


          const options = await fetchCompanyData("");
          // console.log(options);
          let defaultCompanyGroupObj = options?.find((company) => (company.label).includes(responseData.Company));
          // console.log(defaultCompanyGroupObj);
          let defaultRelationship = await api.getRelationship(defaultCompanyGroupObj?.value)
          // console.log(defaultRelationship);

          setSelectedCompany({
            value: defaultCompanyGroupObj?.value,
            label: defaultCompanyGroupObj?.label,
          });

          setSelectGroup({
            value: defaultCompanyGroupObj?.groupId,
            label: defaultCompanyGroupObj?.group,
          });

          console.log(defaultRelationship.Response.Data);

          if (defaultRelationship.Response?.Data) {
            console.log("defaultRelationship.Response", defaultRelationship.Response);

            let defaultRelationshipObj = defaultRelationship.Response?.Data?.find((relationship) => (relationship?.Relationship_Name).includes(responseData.Relationship));
            // console.log(defaultRelationshipObj);
            setSelectRelationship({
              value: defaultRelationshipObj?.Relationship_ID,
              label: defaultRelationshipObj?.Relationship_Name
            });
          }
          setCompanyOptions(options);
          setOtcDiscount(responseData?.OTCDisocuntAmountB)
          setRcDiscount(responseData?.RCDisocuntAmountB)
          setOtcAmount(responseData?.OTCAmount)
          setRcAmount(responseData?.RCAmount)
          ///////////////////////////////////

          setOpportunityData({
            Remarks: responseData.Remarks || "",
            Redunancy: responseData.Redunancy || false,
            Block: responseData.Block || "",
            Status: responseData.Status || "",
            Statuscode: responseData.Statuscode || "",
            OppId: responseData.OppId || "",
            OppStatus: responseData.Statuscode || "",
            LeadId: responseData.LeadId || "",
            PriceList: responseData.PriceList || "",
            Topic: responseData.Topic || "",
            // StateId: responseData.StateId || "",
            // CityId: responseData.CityId || "",
            // AreaId: responseData.AreaId || "",
            BuildingId: responseData.BuildingId || "",
            SpecificArea: responseData.SpecificArea || "",
            SpecificBuilding: responseData.SpecificBuilding || "",
            Building_BuildingStatus: responseData.Building_BuildingStatus || "",
            NoofUsers: responseData.NoOfUsers || "",
            NoOfBeds: responseData.NoOfBeds || "",
            // IndustryId: responseData.IndustryId || "",
            ApprovalRequiredFlag: responseData.ApprovalRequiredFlag || "",
            Reason: responseData.Reason || "",
            Area: responseData.Area || "",
            Subbusinesssegment: responseData.Subbusinesssegment || "",
            Businesssegment: responseData.Businesssegment || "",
            // State: responseData.State || "",
            // Salutation: responseData.Salutation || "",
            Relationship: responseData.Relationship || "",
            PostalCode: responseData.PostalCode || "",
            Mobilephone: responseData.Mobilephone || "",
            Media: responseData.Media || "",
            Lco: responseData.Lco || null,
            // Industry: responseData.Industry || "",
            Group: responseData.Group || "",
            Floor: responseData.Floor || "",
            TPFeasibilty: responseData.TPFeasibilty || "",
            CreateAreaOrBuilding: responseData.CreateAreaOrBuilding || false,
            Firmtype: responseData.Firmtype || "",
            Product: responseData.Product || "",
            ProductSegment: responseData.ProductSegment || "",
            FeasibilityRequired: responseData.FeasibilityRequired || false,
            Existingprovider: responseData.Existingprovider || "",
            Emailaddress: responseData.Emailaddress || "",
            // Country: responseData.Country || "",
            Companyname: responseData.Companyname || "",
            // City: responseData.City || "",
            leadname: responseData.leadname || "",
            Buildingname: responseData.Buildingname || "",
            BuildingNo: responseData.BuildingNo || "",
            ContactPerson: responseData.ContactPerson || "",
            CustomerSegment: responseData.CustomerSegment || "",
            LastMileType: responseData.LastMileType || "",
            UpTimesla: responseData.UpTimesla || "",
            Firewall: responseData.Firewall || "",
            // CompanySelf: responseData.CompanySelf || "",
            PoLock: responseData.PoLock || "",
            Price: responseData.Price || "",
            OriginatingLead: responseData.OriginatingLead || "",
            FirewallAwc: responseData.FirewallAwc || "",
            PoNext: responseData.PoNext || "",
            // Company: responseData.Company || "",
            TotalAmount: responseData.TotalAmount || "",
            VerticalID: responseData.VerticalID || "",
            TypeOfOrder: responseData.TypeOfOrder || "",
            PocClosureDate: responseData.PocClosureDate || "",
            TurnOver: responseData.TurnOver || "",
            SocietyName: responseData.SocietyName || "",
            SocietyId: responseData.SocietyId || "",
            SocietyStatus: responseData.SocietyStatus || "",
            HousePlotFlatNo: responseData.HousePlotFlatNo || "",
            BlockTowerNumber: responseData.BlockTowerNumber || "",
            OTCAmount: responseData.OTCAmount || "",
            SDAmount: responseData.SDAmount || "",
            RCAmount: responseData.RCAmount || "",
            sdDiscount: responseData.SDDiscountAmount || "",
            otcDiscount: responseData.OTCDisocuntAmountB || "",
            rcDiscount: responseData.RCDisocuntAmountB || "",
            exOtcDiscount: responseData.OTCExtendedAmountB || "",
            exSdDiscount: responseData.SDExtendedAmount || "",
            exRcDiscount: responseData.RCExtendedAmountB || ""
          });
          setOtcAmountDis(responseData.OTCDiscountAmount);
          setRcAmountDis(responseData.RCAmount);
          setOtcAmount(responseData.OTCAmount);
          setSdAmount(responseData.SDAmount);
          setleadid(responseData.LeadId);
          // setSelectedPriceList(responseData.PriceList);
          // console.log("responseData.Product", responseData.Product)
          setStatusCode(responseData.Statuscode);
          setStatus(responseData.Status);
          setSelectSociety(responseData.SocietyName);

          setSelectedFirmType(firmtype.find(item => item.value === responseData.Firmtype));
          setSelectedMedia(media.find(item => item.value === responseData.Media));
          setSelectExServiceProvider1(ExServiceProvider.find(item => item.value === responseData.Existingprovider));
          setSelectInterestedFirewall(optionInterestedFirewall.find(item => item.value === responseData.Firewall));
          setSelectInteretedVPN(optionInterestedVPN.find(item => item.value === responseData.Redunancy));
          setSelectInterestedManageWiFi(optionInterestedManageWiFi.find(item => item.value === responseData.CompanySelf));

          // console.log(ExServiceProvider.find(item => item.value === responseData.Existingprovider));

          let getBuilding = await api.getBuilding({ areaName: responseData.AreaId, areaCode: responseData?.AreaId })


          let defaultBuilding = getBuilding?.Response?.Data?.find((building) => building.BuildingCode == responseData?.BuildingId)
          if (defaultBuilding) {
            // console.log(defaultBuilding);
            setSelectBuilding({
              value: defaultBuilding.BuildingCode,
              label: defaultBuilding.BuildingName
            })
          }

          setSelectedProduct({
            value: responseData.Product,
            label: responseData.Product,
          });

          setSelectedPriceList(
            {
              value: responseData.PriceList,
              label: responseData.PriceList,
            }
          )
          setSelectCountry({
            value: responseData.Country,
            label: responseData.Country,
          });
          setSelectState({
            value: responseData.StateId,
            label: responseData.State,
          })
          setSelectCity({
            value: responseData.CityId,
            label: responseData.City,
          })
          setSelectArea({
            value: responseData.AreaId,
            label: responseData.Area,
          })
          setSelectIndustry({
            value: responseData.IndustryId,
            label: responseData.Industry,
          })

          const filterCustomerSegment = optionCustomerSeg.find(item => item.value === String(responseData.CustomerSegment)).label;


          setSelectCustomerSeg(
            {
              value: responseData.CustomerSegment,
              label: filterCustomerSegment,
            });
          // console.log("responseData.TurnOver",responseData.TurnOver);

          const filterTurnOver = optionTurnOver?.find(item => item.value === String(responseData?.TurnOver)).label;
          // console.log("filterTurnOver",filterTurnOver);

          setSelectTurnOver(
            {
              value: responseData.TurnOver,
              label: filterTurnOver,
            });
          const filterSalutationId = optionSolutation.find(
            (item) => item.value === String(responseData.Salutation)
          ).label;
          setSelectSolutaton({
            value: responseData.Salutation,
            label: filterSalutationId,
          });

          // console.log(companyOptions);

          // if (responseData?.Company) {
          //   setSelectedCompany({
          //     value: responseData.Company,
          //     label: responseData.Company,
          //   });
          // }

          //////////////
          // console.log(responseData?.ProductSegment, responseData?.Building_BuildingStatus, responseData?.Redunancy, responseData?.InfraFlag);

          // if ((segment == "BIA" || segment == "ILL") && BuildingStatus == "Non-RFS") {
          //   generateFeasibilityBtn(true)
          //   isRedundancyLocked(false)
          // }
          // if ((segment == "BIA" || segment == "ILL") && BuildingStatus !== "Non-RFS") {
          //   generateFeasibilityBtn(false)
          //   isRedundancyLocked(true)
          // }
          // if ((segment == "MBIA" || segment == "MBB") && RedundancyRequired == "YES") {
          //   generateFeasibilityBtn(true)
          //   isRedundancyLocked(false)
          // }
          // if (segment == "MS WiFi" && RedundancyRequired == "YES" && InfraFlag !== YES) {
          //   generateFeasibilityBtn(true)
          //   isRedundancyLocked(false)
          // }
          // if (segment == "MS WiFi" && RedundancyRequired == "YES" && InfraFlag == YES) {
          //   generateFeasibilityBtn(false)
          //   isRedundancyLocked(true)
          // }

        } else {
          console.error("Error fetching opportunity data:", responseData?.Message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);


  const handleWon = async () => {
    //  console.log(selectedProduct.value);
    const requiredField = {
      "Topic": opportunityData.Topic ? opportunityData.Topic : "",
      "Block": opportunityData.Block || "",
      // "Building": true,
      "Area": selectArea.value || "",
      "BuildingNo": opportunityData.BuildingNo || "",
      "Buildingname": selectBuilding.value || "",
      "City": selectCity?.value ? selectCity.value : "",
      "Company Self": selectInterestedManageWiFi?.value || "",
      "Contact Person": opportunityData.ContactPerson ? opportunityData.ContactPerson : "",
      "Country": "10001",
      "Customer Segment": selectCustomerSeg.value ? selectCustomerSeg.value : "",
      "Email address": opportunityData.Emailaddress ? opportunityData.Emailaddress : "",
      "Existin gprovider": selectExServiceProvider1.value || "",
      "Firewall": selectInterestedFirewall?.value || "",
      "Firmtype": selectedFirmType.value || "",
      "Floor": opportunityData.Floor ? opportunityData.Floor : "",
      "Industry": selectIndustry.value ? selectIndustry.value : "",
      "Media": selectedMedia.value || "",
      "Mobilephone": opportunityData.Mobilephone ? opportunityData.Mobilephone : "",
      // oppId: OppId ? OppId : "",
      "PO Lock": yyyymmddFormat(opportunityData.PoLock) || "",
      "PO Next": yyyymmddFormat(opportunityData.PoNext) || "",
      "Postal Code": opportunityData.PostalCode ? opportunityData.PostalCode : "",
      "Price List": selectedPriceList.value ? selectedPriceList.value : "",
      // reason: opportunityData.Reason ? opportunityData.Reason : "",
      "Redunancy": typeof (selectInterestedVPN?.value) === "boolean" ? selectInterestedVPN?.value : "",  // selectInterestedVPN.value,
      "Salutation": selectSolutaton.value ? selectSolutaton.value : "",
      // specificArea: opportunityData.SpecificArea || "",
      // specificBuilding: opportunityData.SpecificBuilding || "",
      "State": selectState.value ? selectState.value : "",
      "Turn Over": selectTurnOver.value ? selectTurnOver.value : "",
      // typeOfOrder: "",
      "UpTime SLA": opportunityData.UpTimesla || "",
    }

    // console.log(requiredField);

    if (!checkRequiredFields(requiredField)) { return }


    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Action: "wonOpportunity",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        oppid: OppId,
        password: sessionStorage.getItem('password'),
        reason: "",
        siteId: "",
        userName: sessionStorage.getItem('userName'),
      };
      // console.log(requestData);return


      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      // console.log(data);

      // Check for a successful API response
      if (data.Response.StatusCode === 200) {
        toast.success("Opportunity marked as Won", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        window.location.reload()
        // Swal.fire({
        //   title: '<div style="font-size: 22px; margin-top:5px;">Action Required</div>',
        //   text: "Please submit for approval as discount added in OTC or SD amount",
        //   confirmButtonText:
        //     '<span style="font-size: 15px;">Submit for Approval</span>',
        //   confirmButtonColor: "rgb(148,101,170)",
        // }).then(async (result) => {
        //   if (result.isConfirmed) {
        //     const ApiUrl = process.env.REACT_APP_API_URL;
        //     const requestBody = {
        //       "Action": "BBApprovalProcessDigi",
        //       "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        //       "userName": sessionStorage.getItem('userName'),
        //       "password": sessionStorage.getItem('password'),
        //       "OpportunityID": OppId,
        //       "ApprovalRemarks": "Ignore"
        //     };
        //     const Response = await fetch(ApiUrl, {
        //       method: "POST",
        //       headers: {
        //         "Content-Type": "application/json",
        //       },
        //       body: JSON.stringify(requestBody),
        //     });
        //     const data = await Response.json();
        //     console.log(data)
        //     if (data.StatusCode == "200") {
        //       // navigate("/opportunity");
        //     }
        //   }
        // })
      } else {
        toast.warning(data.Response.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });

      }
    } catch (error) {
      console.error("Error during API call:", error);
    } finally {
      setLoading(false);
    }

  };


  const handleLost = async () => {
    // console.log("Opportunity marked as Lost");
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData =
      {
        "Action": "lostOpportunity",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "Oppid": OppId,
        "password": sessionStorage.getItem('password'),
        "status": "569480010",
        "userName": sessionStorage.getItem('userName')
      }
      // console.log(requestData);return


      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      // console.log(data);

      // Check for a successful API response
      if (data.Response.StatusCode === 200) {
        toast.success("Opportunity marked as Lost", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        // window.location.reload()
        navigate(`/businessOpportunity`);

      } else {
        toast.warning(data.Response.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });

      }
    } catch (error) {
      console.error("Error during API call:", error);
    } finally {
      setLoading(false);
    }
  };




  const handleSendToApproval = () => {
    try {
      Swal.fire({
        title: '<div style="font-size: 22px; margin-top:5px;">Action Required</div>',
        text: "Please submit for approval as discount added in OTC or RC amount",
        confirmButtonText:
          '<span style="font-size: 15px;">Submit for Approval</span>',
        confirmButtonColor: "rgb(148,101,170)",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { value: formValues } = await Swal.fire({
            title: `<div style="font-size: 15px;padding: 10px;">Enter Reason for Discount</div>`,
            // html: `<div style="font-size: 15px;">Reason of Payment DOA</div>`,
            html: `
                                              <input id="swal-input1" class="swal2-input">  `,
            focusConfirm: false,
            preConfirm: () => {
              // return [document.getElementById("swal-input1").value];
              const reason = document.getElementById("swal-input1").value.trim();
              if (!reason) {
                Swal.showValidationMessage("Reason is required.");
                return;
              }
              return reason;
            }
          });
          if (formValues) {
            const ApiUrl = process.env.REACT_APP_API_URL;
            const requestBody = {
              "Action": "createApproval",
              "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
              "userName": sessionStorage.getItem('userName'),
              "password": sessionStorage.getItem('password'),
              "oppid": OppId ? OppId : "",
              "reason": formValues
            };
            const Response = await fetch(ApiUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(requestBody),
            });
            const data = await Response.json();
            // console.log(data)
            if (data.Status == "Success") {
              toast.success(data.Response.Message, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
              });
              window.location.reload()
            }
          }
        }
      })
    }
    catch (error) {
      console.error("Error during API call:", error);
    }
  }


  const checkRequiredFields = (payload) => {
    for (const key in payload) {
      // console.log(key, ":", payload[key]);

      if (payload[key] === "" || payload[key] === null) {
        // console.log(payload[key]);
        toast.error(`Required field: ${key}`, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return false; // Stop execution if any field is empty
      }
    }
    return true; // All fields are valid
  };





  const handleUpdateOpportunity = async (event) => {
    try {
      setLoading(true);
      event.preventDefault(); // Prevent default submission


      if (opportunityData?.ProductSegment == "Managed Wi-Fi Business-S" || opportunityData?.ProductSegment == "Managed Wi-Fi Business") {
        try {
          // console.log(opportunitySurveyData);

          // ********** Validate Industry Type ********** //
          if (!selectIndustry) {
            toast.error("Please enter Industry Type.")
            return;
          } else if (selectIndustry?.label == "Hospitality" && !opportunitySurveyData.NoofRooms) {
            toast.error("Please enter No. of Rooms.")
            return;
          } else if (selectIndustry?.label == "Co-Living" && !opportunitySurveyData.NoofBeds) {
            toast.error("Please enter No. of Beds.")
            return;
          } else if (selectIndustry?.label == "Co-Working" && !opportunitySurveyData.NoofSeats) {
            toast.error("Please enter No. of Seats.")
            return;
          } else if (selectIndustry?.label !== "Co-Living" && selectIndustry?.label !== "Co-Working" && selectIndustry?.label !== "Hospitality" && !opportunityData?.NoofUsers) {
            toast.error("Please enter No. of Users.")
            return;
          }


          // ********** Validate Network Security required ********** //
          if (getPreSalesTask[0]?.MeetingDoneWithCustomer == "Yes") {
            if (!opportunitySurveyData?.NetworkSecurityrequired) {
              toast.error("Please enter Network Security Required.")
              return;
            } else if (opportunitySurveyData?.NetworkSecurityrequired && (opportunitySurveyData?.NetworkSecurityrequired == "111260000" || opportunitySurveyData?.NetworkSecurityrequired == "111260001")) {
              if (!opportunitySurveyData.Anyspecificsecurity) {
                toast.error("Please enter Network Security Required.")
                return;
              }
            }

            // ********** Validate Bandwidth Required ********** //

            if (!opportunitySurveyData?.BandwidthRequired) {
              toast.error("Please enter Bandwidth Required.")
              return;
            } else if (opportunitySurveyData?.BandwidthRequired == "111260001") {
              if (!opportunitySurveyData?.BandwidthType) {
                toast.error("Please enter Bandwidth Type.")
                return;
              } else if (opportunitySurveyData?.BandwidthType == "111260000" || opportunitySurveyData?.BandwidthType == "111260001") {
                if (!opportunitySurveyData.RequiredBandwidthinMbps) {
                  toast.error("Please enter Required Bandwidth (in Mbps).")
                  return;
                }
              }
            } else if (opportunitySurveyData?.BandwidthRequired == "111260000") {
              if (opportunitySurveyData?.Countofexistinginternetlinks == "111260000") {
                if (!opportunitySurveyData?.TypeofexistinginternetLink1) {
                  toast.error("Please enter Type of existing internet Link 1.")
                  return;
                } else if (!opportunitySurveyData.BandwidthoFexistinginternetLinkMbps1) {
                  toast.error("Please enter Bandwidth of existing internet Link (Mbps) 1.")
                  return;
                }
              } else if (opportunitySurveyData?.Countofexistinginternetlinks == "111260001") {
                if (!opportunitySurveyData?.TypeofexistinginternetLink1) {
                  toast.error("Please enter Type of existing internet Link 1.")
                  return;
                } else if (!opportunitySurveyData.BandwidthoFexistinginternetLinkMbps1) {
                  toast.error("Please enter Bandwidth of existing internet Link (Mbps) 1.")
                  return;
                } else if (!opportunitySurveyData.TypeofexistinginternetLink2) {
                  toast.error("Please enter Type of existing internet Link 2")
                  return;
                } else if (!opportunitySurveyData.BandwidthoFexistinginternetLinkMbps2) {
                  toast.error("Please enter Bandwidth of existing internet Link (Mbps) 2")
                  return;
                }
              }

            }

            // ********** Validate Wired LAN Integration ********** //
            if (!opportunitySurveyData?.WiredLANIntegration) {
              toast.error("Please enter Wired LAN Integration")
              return;
            } else if (opportunitySurveyData?.WiredLANIntegration == "111260000") {
              if (!opportunitySurveyData?.NoofwiredLANports) {
                toast.error("Please enter No. of wired LAN ports")
                return;
              } else if (!opportunitySurveyData?.TypeofWiredLANSetup) {
                toast.error("Please enter Type of Wired LAN Setup")
                return;
              } else if (opportunitySurveyData?.TypeofWiredLANSetup == "111260000" && !opportunitySurveyData?.MakeModelLANswitches) {
                toast.error("Please enter Make/Model and number of existing LAN switches")
                return;
              }
            }

            // ********** Validate Building and Floor Plan ********** //
            if (opportunitySurveyData?.BuildingandFloorPlan == "111260000") {
              if (!opportunitySurveyData?.BuildingFloorAttachment?.FileNameWithExtension) {
                toast.error("Please enter Building and Floor Plan attachment.")
                return;
              }
            }
          }


          const updateSurvey = await api.updateopportunityWiFi(opportunitySurveyData)
          // console.log(updateSurvey);
        } catch (err) { console.error(err); }
      }

      const requiredField = {
        "Topic": opportunityData.Topic ? opportunityData.Topic : "",
        "Block": opportunityData.Block || "",
        // "Building": true,
        "Area": selectArea.value || "",
        "BuildingNo": opportunityData.BuildingNo || "",
        "Buildingname": selectBuilding.value || "",
        "City": selectCity?.value ? selectCity.value : "",
        "Company Self": selectInterestedManageWiFi?.value || "",
        "Contact Person": opportunityData.ContactPerson ? opportunityData.ContactPerson : "",
        "Country": "10001",
        "Customer Segment": selectCustomerSeg.value ? selectCustomerSeg.value : "",
        "Email address": opportunityData.Emailaddress ? opportunityData.Emailaddress : "",
        "Existin gprovider": selectExServiceProvider1.value || "",
        "Firewall": selectInterestedFirewall?.value || "",
        "Firmtype": selectedFirmType.value || "",
        "Floor": opportunityData.Floor ? opportunityData.Floor : "",
        "Industry": selectIndustry.value ? selectIndustry.value : "",
        "Media": selectedMedia.value || "",
        "Mobilephone": opportunityData.Mobilephone ? opportunityData.Mobilephone : "",
        // oppId: OppId ? OppId : "",
        "PO Lock": yyyymmddFormat(opportunityData.PoLock) || "",
        "PO Next": yyyymmddFormat(opportunityData.PoNext) || "",
        "Postal Code": opportunityData.PostalCode ? opportunityData.PostalCode : "",
        "Price List": selectedPriceList.value ? selectedPriceList.value : "",
        // reason: opportunityData.Reason ? opportunityData.Reason : "",
        "Redunancy": typeof (selectInterestedVPN?.value) === "boolean" ? selectInterestedVPN?.value : "",  // selectInterestedVPN.value,
        "Salutation": selectSolutaton.value ? selectSolutaton.value : "",
        // specificArea: opportunityData.SpecificArea || "",
        // specificBuilding: opportunityData.SpecificBuilding || "",
        "State": selectState.value ? selectState.value : "",
        "Turn Over": selectTurnOver.value ? selectTurnOver.value : "",
        // typeOfOrder: "",
        "UpTime SLA": opportunityData.UpTimesla || "",
      }

      // console.log(requiredField);
      if (!checkRequiredFields(requiredField)) { return }

      // if (otcAmount > opportunityData.OTCAmount) {
      //   toast.error("OTC Amount can't be less than the existing amount.");
      //   return;
      // } else if (otcAmount > opportunityData.RCAmount) {
      //   toast.error("RC Amount can't be less than the existing amount.");
      //   return;
      // }

      setLoader(true)
      const apiUrl = process.env.REACT_APP_API_URL
      const payload = {
        Action: "updateopportunity",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        Remarks: opportunityData.Remarks,
        block: opportunityData.Block || "",
        createAreaOrBuilding: true,
        firewallAwc: yyyymmddFormat(opportunityData?.FirewallAMCExpiryDate) || "",
        pocClosureDate: "",
        area: selectArea.value || "",
        buildingNo: opportunityData.BuildingNo || "",
        buildingname: selectBuilding.value || "",
        city: selectCity.value ? selectCity.value : "",
        companySelf: selectInterestedManageWiFi.value || "",
        contactPerson: opportunityData.ContactPerson ? opportunityData.ContactPerson : "",
        country: "10001",
        customerSegment: selectCustomerSeg.value ? selectCustomerSeg.value : "",
        emailaddress: opportunityData.Emailaddress ? opportunityData.Emailaddress : "",
        existingprovider: selectExServiceProvider1.value || "",
        firewall: selectInterestedFirewall?.value || "",
        firmtype: selectedFirmType.value || "",
        floor: opportunityData.Floor ? opportunityData.Floor : "",
        industry: selectIndustry.value ? selectIndustry.value : "",
        lco: "",
        media: selectedMedia.value,
        mobilephone: opportunityData.Mobilephone ? opportunityData.Mobilephone : "",
        noOfBeds: "",
        noOfUsers: "",
        oppId: OppId ? OppId : "",
        poLock: yyyymmddFormat(opportunityData.PoLock) || "",
        poNext: yyyymmddFormat(opportunityData.PoNext) || "",
        postalCode: opportunityData.PostalCode ? opportunityData.PostalCode : "",
        priceList: selectedPriceList.value ? selectedPriceList.value : "",
        reason: opportunityData.Reason ? opportunityData.Reason : "",
        redunancy: selectInterestedVPN?.value ? selectInterestedVPN?.value : false,
        salutation: selectSolutaton.value ? selectSolutaton.value : "",
        specificArea: opportunityData.SpecificArea || "",
        specificBuilding: opportunityData.SpecificBuilding || "",
        state: selectState.value ? selectState.value : "",
        topic: opportunityData.Topic ? opportunityData.Topic : "",
        turnOver: selectTurnOver.value ? selectTurnOver.value : "",
        typeOfOrder: "",
        upTimesla: opportunityData.UpTimesla || "",
        societyId: opportunityData.SocietyId || "",
        housePlotFlatNo: opportunityData.HousePlotFlatNo ? opportunityData.HousePlotFlatNo : "",
        blockTowerNumber: opportunityData.BlockTowerNumber ? opportunityData.BlockTowerNumber : "",
        otcAmount: opportunityData.OTCAmount ? opportunityData.OTCAmount : "",
        sdAmount: opportunityData.SDAmount ? opportunityData.SDAmount : "",
        // otcAmountDis: opportunityData.otcDiscount ? opportunityData.otcDiscount : "",
        // OTCDiscountAmount: opportunityData.otcDiscount ? opportunityData.otcDiscount : "",
        // sdAmountDis: opportunityData.sdDiscount ? opportunityData.sdDiscount : "",
        // RCDiscountAmount: opportunityData.rcDiscount ? opportunityData.rcDiscount : "",
        password: sessionStorage.getItem('password'),
        userName: sessionStorage.getItem('userName'),
        SDWANOpp: {
          firewallSetToExpire: SdwanOpp.FirewallSetToExpire,
          mPLSContract: SdwanOpp.MPLSContract,
          applicationsHosted: SdwanOpp.ApplicationsHosted,
          // If a city has been selected, use its value; otherwise, default to an empty string.
          currentOperationalCity: selectCurrentWorkLocation?.value || "",
          customerBroadbandServices: SdwanOpp.CustomerBroadbandServices,
          customerILLservices: SdwanOpp.CustomerILLservices,
          customerRoutingServices: SdwanOpp.CustomerRoutingServices,
          indicationITSpent: SdwanOpp.IndicationITSpent,
          itSupport: SdwanOpp.ItSupport,
          linksManagedLinks: SdwanOpp.LinksManagedLinks,
          mPLSBackbone: SdwanOpp.MPLSBackbone,
          networkSecurityServices: SdwanOpp.NetworkSecurityServices,
          noOfLocation: SdwanOpp.NoOfLocation,
          numberOfLinksBroadbandServices: SdwanOpp.NumberOfLinksBroadbandServices,
          numberOfLinksIll: SdwanOpp.NumberOfLinksIll,
          redundancyMPLS: SdwanOpp.RedundancyMPLS,
          sdwanRemarks: SdwanOpp.SdwanRemarks
        },
      };



      // Send API request
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (opportunityData?.Product && (opportunityData?.otcDiscount || opportunityData?.rcDiscount)) {
        let updateProductreq = { productid: opportunityData.Product, discount: opportunityData.otcDiscount };
        let updateProduct = await api.updateOppProduct(updateProductreq)
      }

      if (result?.Status === "Success") {
        // if (selectedProduct && opportunityData.FeasibilityRequired && getFeasibilityData?.length < 0) {
        //   try {
        //     const createFeasibility = await api.generateFeasibility(OppId);
        //     console.log(createFeasibility);
        //   } catch (err) { console.error(err); }
        // }

        // console.log(opportunityData.otcDiscount, opportunityData.rcDiscount);

        if (opportunityData.otcDiscount || opportunityData.rcDiscount) {
          try {
            // console.log("Raise DOA Approval via Api");
          } catch (err) { console.error(err); }
        }


        toast.success("Opportunity updated successfully!", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });

        setTimeout(() => {
          window.location.reload()
        }, 1500);
      } else {
        toast.warning("Failed to update opportunity!", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return
      }

      // const updateSurvey = await api.updateopportunityWiFi(opportunitySurveyData)
      // console.log(updateSurvey);
    } catch (error) {
      console.error("Error updating opportunity:", error);
      // toast.error("Error updating opportunity.");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      const getrelationship = await api.getRelationship(selectedCompany?.value)

      // console.log(getrelationship?.Response);

      if (!Array.isArray(getrelationship?.Response)) { return }

      setRelationOptions(getrelationship?.Response?.map((relationship) => (
        {
          value: relationship.Relationship_ID,
          label: relationship.Relationship_Name,
        }
      )));



    }

    fetchData()

  }, [selectedCompany]);

  useEffect(() => {
    const getCompanyGrouplist = async () => {
      const getCompany = await api.getCompanyGroup("New Company")
      const oppProduct = await api.getOppProduct({ oppid: OppId });
      // console.log(oppProduct);
      // console.log(oppProduct.Response?.Data);

      // let relProductRC = oppProduct?.Response?.Data?.filter((data) => data.ProductId.includes("-RC"))
      // let relProductOTC = oppProduct?.Response?.Data?.filter((data) => data.ProductId.includes("-OTC"))

      let relProductRC = oppProduct?.Response?.Data?.filter((data) => (data.ProductId.includes("RC") && !data.ProductId.includes("_IPADDRESS_")))
      let relProductOTC = oppProduct?.Response?.Data?.filter((data) => (data.ProductId.includes("OTC") && !data.ProductId.includes("_IPADDRESS_")))
      let relProductIP = oppProduct?.Response?.Data?.filter((data) => data.ProductId.includes("IPADDRESS"))

      // console.log(relProductRC, relProductOTC);
      setRCProd(relProductRC)
      setOTCProd(relProductOTC)

      relProductIP?.length > 0 && setIpProd(relProductIP)


      setRelatedProductOptions(oppProduct?.Response?.Data?.map((data) => (
        {
          value: data.ProductId,
          label: data.ProductId
          ,
        }
      )))

      // selectedRelatedProduct()
      // relatedProductOptions()

      setGroupOptions(getCompany?.Response?.Data?.map((data) => (
        {
          value: data.Group_ID,
          label: data.Group_Name,
        }
      )))

      setCompanyOptions(getCompany.Response.Data?.map((data) => (
        {
          value: data.Company_ID,
          label: data.Company_Name,
        }
      )))
    };

    getCompanyGrouplist()

  }, []);

  useEffect(() => {
    const fetchGetIndustry = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getindustrytype",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          areaCode: "",
          areaName: "",
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        const result = await response.json();
        if (result.Status == "Success") {
          const industryType = result.Response.map(
            (option) => ({
              label: option.IndTypeName,
              value: option.IndTypeId,
            })
          );
          setindustrydropdetails(industryType);
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {

      }
    };

    fetchGetIndustry();
  }, []);



  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const payload = {
          Action: "getPricelist",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          buildingname: selectSociety ? selectSociety : "",
          password: sessionStorage.getItem('password'),
          userName: sessionStorage.getItem('userName')
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        const result = await response.json();

        if (result?.Status === "Success" && result?.Response?.Data) {

          const priceList = result.Response.Data.map(
            (option) => ({
              label: option.PriceName,
              value: option.PriceName,
            })
          );
          setPriceListOptions(priceList);

        } else {
          console.error("Failed to retrieve price list:", result);
        }
      } catch (error) {
        console.error("Error fetching price list:", error);
      }
    }; fetchData();
  }, [selectSociety]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const payload = {
          Action: "getProductlist",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          oppid: OppId ? OppId : "",
          reason: "",
          siteId: "",
          password: sessionStorage.getItem('password'),
          userName: sessionStorage.getItem('userName'),
        };

        // Send API request
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
        const result = await response.json();
        // console.log(result);

        if (result?.Status === "Success") {
          // const productList = result.Response.Data.map(item => item.ProductId);
          // console.log("result.Response.Data", result.Response.Data)
          const productList = result.Response.Data.map(
            (option) => ({
              label: option.ProductId,
              value: option.ProductId,
            })
          );
          setProductOptions(productList);
        }
      } catch (error) {
        console.error("Error fetching product list:", error);
      }
    }; fetchData();
  }, []);

  const relatedProductChange = async (selectedOption) => {
    // console.log(selectedOption);
    // selectedOption.value.includes("-RC")
    setSelectedRelatedProduct(selectedOption);

    if (selectedOption.value.includes("-OTC")) {
      setDiscountFlag("OTC")
      // setOpportunityData((prevData) => ({
      //   ...prevData,
      //   otcDiscount: ""
      // }));
    } else if (selectedOption.value.includes("-RC")) {
      setDiscountFlag("RC")
      // setOpportunityData((prevData) => ({
      //   ...prevData,
      //   rcDiscount: ""
      // }));
    } else {
      setDiscountFlag()
    }
  }


  const handleProductChange = async (selectedOption) => {
    setSelectedProduct(selectedOption);
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestBody = {
        Action: "createOppProduct",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        oppid: OppId ? OppId : "",
        password: sessionStorage.getItem('password'),
        productid: selectedOption.value,
        userName: sessionStorage.getItem('userName'),
      };
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const responsedata = await response.json();

      if (responsedata.Status == "Failure") {
        toast.warning(responsedata.Response.Message.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }

    } catch (error) {
      // Handle fetch error
      console.error("Error fetching data:", error);
    }
  };

  const redirectoppPage = () => {
    Swal.fire({
      html: '<div style="font-size: 15px;">Do you want to go back to the previous screen?</div>',
      showCancelButton: true,
      confirmButtonText:
        '<span style="font-size: 12px;color:rgb(148,101,170);">YES</span>',
      cancelButtonText:
        '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
      confirmButtonColor: "white",
      cancelButtonColor: "white",
      customClass: {
        popup: "custom-popup",
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/businessOpportunity");
      }
    });
  };



  const fetchCompanyData = async () => {
    try {
      setLoader(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestBody = {
        Action: "getCompany",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        companyId: "New Company",
        password: sessionStorage.getItem('password'),
        userName: sessionStorage.getItem('userName'),
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      // console.log("conpany name :", data.Response.Data);
      if (data.Status === "Success" && data.StatusCode === "200") {
        return data.Response.Data.map((company) => ({
          label: `${company.Company_Name} (${company.Company_ID})`,
          value: company.Company_ID,
          group: `${company.Group_Name} (${company.Group_ID})`,
          groupId: company.Group_ID,
        }));
      } else {
        console.error("Error in API response:", data);
        return [];
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    } finally {
      setLoader(false);
    }
    return [];
  };

  useEffect(() => {
    const fetchCities = async () => {
      try {
        // City API call
        const cityApiUrl = process.env.REACT_APP_API_URL;
        const cityRequestBody = {
          Action: "getCity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          password: sessionStorage.getItem('password'),
          stateCode: selectState.value,
          userName: sessionStorage.getItem('userName'),
        };
        const cityResponse = await fetch(cityApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cityRequestBody),
        });
        const cityData = await cityResponse.json();

        if (cityData.Response && Array.isArray(cityData.Response.Data)) {
          setCityType(cityData.Response.Data);
        } else {
          // console.error(
          //   "City data structure not recognized:",
          //   cityData.Response
          // );

          setCityType([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (selectState) {
      fetchCities();
    }
  }, [selectState]);



  const handleSelectCity = async (selectedOption) => {
    const selectedCityCode = selectedOption ? selectedOption.value : "";
    const selectedCityName = selectedOption ? selectedOption.label : "";
    // console.log("selectedCityCode", selectedOption.value);
    // console.log("selectedCityName", selectedOption.label);
    setSelectCity(selectedOption);
    setSelectArea("");
    // setSelectBuilding("");
    try {
      const areaApiUrl = process.env.REACT_APP_API_URL;
      const areaRequestBody = {
        Action: "getArea",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        cityCode: selectedCityCode,
        cityName: selectedCityName,
        password: sessionStorage.getItem('password'),
        restrictedarea: false,
        stateCode: "",
        userName: sessionStorage.getItem('userName'),
      };
      const areaResponse = await fetch(areaApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(areaRequestBody),
      });
      const areaData = await areaResponse.json();
      if (areaData.Response && Array.isArray(areaData.Response.Data)) {
        // console.log("area :", areaData.Response.Data);
        setAreaList(areaData.Response.Data);
      }
    } catch (error) {
      console.error("Error fetching area data:", error);
    }
  };

  const handleSelectArea = async (selectedOption) => {
    try {
      // console.log(selectedOption);

      setSelectArea(selectedOption);
      setSelectBuilding("");


      let payload = {
        areaCode: selectedOption.value,
        areaName: selectedOption.label.split(" ")[0]
      }
      let getBuilding = await api.getBuilding(payload);
      // console.log("getBuilding: ", getBuilding);

      if (getBuilding.Response && Array.isArray(getBuilding.Response.Data)) {
        setBuildingList(getBuilding.Response.Data);
      }
    } catch (error) {
      console.error("Error fetching building data:", error);
    }
  };

  // ================ MS-WIFI =======================

  const getWiredLANIntegrationOptions = wifiOptions.getWiredLANIntegrationOptions()
  const getBuildingAndFloorPlanOptions = wifiOptions.getBuildingAndFloorPlanOptions()
  const getNetworkSecurityRequiredOptions = wifiOptions.getNetworkSecurityRequiredOptions();
  const getExistingNetworkSecurityDeviceOptions = wifiOptions.getExistingNetworkSecurityDeviceOptions();
  const getSeparateNetworkForBackOfficeOptions = wifiOptions.getSeparateNetworkForBackOfficeOptions();
  const getBandwidthRequiredOptions = wifiOptions.getBandwidthRequiredOptions();
  const getExistingWiFiCablingByCustomerOptions = wifiOptions.getExistingWiFiCablingByCustomerOptions();
  const getAPIIntegrationRequiredOptions = wifiOptions.getAPIIntegrationRequiredOptions();
  const getPMSVendorForAPIIntegrationOptions = wifiOptions.getPMSVendorForAPIIntegrationOptions();
  const getAnyIOTDevicesToBeConnectedOptions = wifiOptions.getAnyIOTDevicesToBeConnectedOptions();
  const getCountOfExistingInternetLinksOptions = wifiOptions.getCountOfExistingInternetLinksOptions();
  const getTypeOfExistingInternetLinkOptions = wifiOptions.getTypeOfExistingInternetLinkOptions();
  const getUserTypeOptions = wifiOptions.getUserTypeOptions();
  const getSpeedPerUserOptions = wifiOptions.getSpeedPerUserOptions();
  const getLoginMechanismOptions = wifiOptions.getLoginMechanismOptions();
  const getPlanValidityDataVolumeCriteriaOptions = wifiOptions.getPlanValidityDataVolumeCriteriaOptions();
  const getBandwidthTypeOptions = wifiOptions.getBandwidthTypeOptions();
  const getTypeOfWiredLANSetupOptions = wifiOptions.getTypeOfWiredLANSetupOptions();
  const [selectedDropdownObj, setSelectedDropdownObj] = useState({})
  const [opportunitySurveyData, setOpportunitySurveyData] = useState({
    "Action": "updateopportunityWiFi",
    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
    "userName": sessionStorage.getItem('userName'),
    "password": sessionStorage.getItem('password')
  })

  // console.log("opportunitySurveyData", opportunitySurveyData);


  const [getCreateGridData, setCreateGridData] = useState({
    "Action": "createUserlicenceGrid",
    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
    "userName": sessionStorage.getItem('userName'),
    "password": sessionStorage.getItem('password')
  })
  const [oppWifiData, setOppWifiData] = useState({})

  const formInputData = (e) => {
    const { name, value, type } = e.target;
    // console.log(name, value);

    setOpportunitySurveyData((prevData) => ({
      ...prevData,
      [name]: type === "number" ? String(value) : value,
    }));

  };

  const formDropdownInput = (name, value) => {
    // console.log(name, value);
    // console.log("opportunitySurveyData", opportunitySurveyData);

    setOpportunitySurveyData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // const formDropdownInputGrid = (name, value) => {
  //   // const { name, value } = e.target;
  //   console.log(name, value);
  //   // console.log("opportunitySurveyData", getCreateGridData);

  //   setCreateGridData((prevData) => ({
  //     ...prevData,
  //     [name]: value,
  //   }));
  // };


  // const formInputGrid = (e) => {
  //   const { name, value } = e.target;
  //   // console.log(name, value);

  //   setCreateGridData((prevData) => ({
  //     ...prevData,
  //     [name]: value,
  //   }));
  // };

  useEffect(() => {
    async function fetchData() {
      try {
        const oppData = await api.getopportunityWiFi(OppId);
        if (oppData?.Status == "Success") {
          const opportunityData = oppData?.Response?.oppDetails;
          // console.log(opportunityData);

          setOpportunitySurveyData((prevData) => ({
            ...prevData,
            "NoofUsers": opportunityData?.NoofUsers || "",
            "BuildingFloorAttachment": opportunityData?.BuildingFloorAttachment || "",
            "OppId": OppId || "",
            "SiteName": opportunityData?.SiteName || "",
            "CustomerContactName": opportunityData?.CustomerContactName || "",
            "CustomerContactNumber": opportunityData?.CustomerContactNumber || "",
            "Customeremailidsitespoc": opportunityData?.Customeremailidsitespoc || "",
            "ListofBuildings": opportunityData?.ListofBuildings || "",
            "AreatobeCovered": opportunityData?.AreatobeCovered || "",
            "BuildingandFloorPlan": opportunityData?.BuildingandFloorPlan || "",
            "NetworkSecurityrequired": opportunityData?.NetworkSecurityrequired || "",
            "Anyspecificsecurity": opportunityData?.Anyspecificsecurity || "",
            "MakeModelofexisting": opportunityData?.MakeModelofexisting || "",
            "ExistingNetworkSecurityDevice": opportunityData?.ExistingNetworkSecurityDevice || "",
            "LinkTerminatingFloor": opportunityData?.LinkTerminatingFloor || "",
            "BandwidthRequired": opportunityData?.BandwidthRequired || "",
            "Countofexistinginternetlinks": opportunityData?.Countofexistinginternetlinks || "",
            "ISPofexistinginternetLink1": opportunityData?.ISPofexistinginternetLink1 || "",
            "TypeofexistinginternetLink1": opportunityData?.TypeofexistinginternetLink1 || "",
            "BandwidthoFexistinginternetLinkMbps1": opportunityData?.BandwidthoFexistinginternetLinkMbps1 || "",
            "ISPofexistinginternetLink2": opportunityData?.ISPofexistinginternetLink2 || "",
            "TypeofexistinginternetLink2": opportunityData?.TypeofexistinginternetLink2 || "",
            "BandwidthoFexistinginternetLinkMbps2": opportunityData?.BandwidthoFexistinginternetLinkMbps2 || "",
            "BandwidthType": opportunityData?.BandwidthType || "",
            "RequiredBandwidthinMbps": opportunityData?.RequiredBandwidthinMbps || "",
            "WiredLANIntegration": opportunityData?.WiredLANIntegration || "",
            "NoofwiredLANports": opportunityData?.NoofwiredLANports || "",
            "TypeofWiredLANSetup": opportunityData?.TypeofWiredLANSetup || "",
            "MakeModelLANswitches": opportunityData?.MakeModelLANswitches || "",
            "ExistingWiFiCabling": opportunityData?.ExistingWiFiCabling || "",
            "APIintegrationrequired": opportunityData?.APIintegrationrequired || "",
            "PMSVendorforAPIIntegration": opportunityData?.PMSVendorforAPIIntegration || "",
            "AnyIOTdevicestobeconnected": opportunityData?.AnyIOTdevicestobeconnected || "",
            "Tentativecountofdevices": opportunityData?.Tentativecountofdevices || "",
            "SeparatenetworkBackoffice": opportunityData?.SeparatenetworkBackoffice || "",
            "SpecialRequest": opportunityData?.SpecialRequest || "",
            "NoofUsers": opportunityData?.NoOfUsers || "",

          }));

          // setSelectedDropdownObj
          const BuildingandFloorPlan = getBuildingAndFloorPlanOptions



        } else {
          throw new Error("getopportunityWiFi API Failure.");
        }
      } catch (err) {
        console.error(err);
      }
    }
    fetchData();
  }, []);


  const handleUserLicenceGrid = async () => {
    // console.log("rtyu");

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        "Action": "createUserlicenceGrid",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "userName": sessionStorage.getItem('userName'),
        "password": sessionStorage.getItem('password'),
        "OppId": OppId ? OppId : "",
        "UserType": userType.value ? userType.value : "",
        "NoofUserLicensesrequired": opportunityData.noUserLicences ? opportunityData.noUserLicences : "",
        "SpeedPerUser": speedPerUser.value ? speedPerUser.value : "",
        "PlanValidityDataVolumeCriteria": planValidity.value ? planValidity.value : "",
        "DataVolumeinGB": opportunityData.dataValume ? opportunityData.dataValume : "",
        "DevicesperUser": opportunityData.devicesPerUser ? opportunityData.devicesPerUser : "",
        "LoginMechanism": loginMechanism.value ? loginMechanism.value : ""
      }
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      if (data.Response.StatusCode == 200) {
        toast.success(data.Response.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }

    } catch (error) {
      console.error(error);
      toast.error("An error occurred. Please try again later.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
  }

  const handleUserType = (selectedState) => {
    setUserType(selectedState);
  };

  const handleSpeedPerUser = (selectedState) => {
    setSpeedPerUser(selectedState);
  };

  const handlePlanValidity = (selectedState) => {
    setPlanValidity(selectedState);
  };

  const handleLoginMechanism = (selectedState) => {
    setLoginMechanism(selectedState);
  };


  const deleteOppProduct = async (selectedOption) => {
    setSelectedProduct(selectedOption);
    try {
      if (!getOppProduct) { return }

      const deleteOppProduct = await api.deleteOpportunityProduct({ Oppid: OppId, productid: getOppProduct })
      // console.log(deleteOppProduct);

      if (deleteOppProduct?.Response?.StatusCode == 200) {
        toast.success("Product deleted successfully!")
        window.location.reload();
      } else {
        toast.error("Failed to delete Product.")
        window.location.reload();
      }

    } catch (error) {
      // Handle fetch error
      console.error("Error fetching data:", error);
    }
  };

  // ====================== MS-WIFI ======================= 

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "black",
      color: "white",
      border: "none",
      boxShadow: state.isFocused ? "none" : provided.boxShadow,
      textAlign: "center",
      fontSize: "15px"
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "white",
    }),
    option: (provided, state) => ({
      ...provided,
      // backgroundColor: state.isFocused ? 'blue' : 'black',
      color: "black",
      textAlign: "center",
    }),
  };


  // ====================== SDWAN ======================= 


  const convertToISOFormat = (dateStr) => {
    if (!dateStr) return "";
    const parts = dateStr.split("-");
    // If the first part has 4 digits, assume it's already in ISO format
    if (parts[0].length === 4) return dateStr;
    const [day, month, year] = parts;
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    // Replace with your actual API endpoint
    fetch(process.env.REACT_APP_API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        Action: "getVertical",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        // password: "S@lesperson@20#!24$",
        stateCode: "",
        password: sessionStorage.getItem('password'),
        userName: sessionStorage.getItem('userName'),
        // userName: "salesperson1"
      })
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.Status === "Success") {
          const options = data.Response.Data.map((vertical) => ({
            value: vertical.VerticalId,
            label: vertical.VerticalName
          }));
          setVerticalOptions(options);
        }
      })
      .catch((error) => console.error("Error fetching verticals:", error));
  }, []);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSdwanOpp(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSelectChange = (name, selectedOption) => {
    setSdwanOpp((prev) => ({
      ...prev,
      [name]: selectedOption.value
    }));
  };

  const handleAddSite = () => {
    // navigate('/businessSitedetails?OppId=${OppId}');
    navigate(`/businessSitedetails?OppId=${OppId}`)

  };

  // ====================submit For Approval button condition start =================
  const isSDWAN = OppSubSeg === "SDWAN";

  const isValidStatus =
    opportunityData?.Statuscode !== "Approved" &&
    opportunityData?.Statuscode !== "Won" &&
    opportunityData?.Statuscode !== "Waiting for Approval";

  const isSDWANCondition =
    opportunityData?.ApprovalRequiredFlag === "yes" && isValidStatus;

  const isSpecialSegment =
    opportunityData?.ProductSegment === "DIA" ||
    opportunityData?.ProductSegment === "Secured Managed Internet";

  const isNonSDWANCondition =
    opportunityData?.Status !== "Lost" &&
    isValidStatus &&
    (
      isSpecialSegment ||
      (getRcDiscount > 0 && getOtcDiscount >= 0)
    );

  const isDiscountValid =
    isSpecialSegment ||
    (
      parseFloat(opportunityData?.OTCAmount) > parseFloat(getOtcDiscount) &&
      parseFloat(opportunityData?.RCAmount) > parseFloat(getRcDiscount)
    );

  // ====================submit For Approval button condition end =================

  // ====================WON button condition start =================
  // const isSDWAN = OppSubSeg === "SDWAN";
  const isNotWon = opportunityData?.Status !== "Won";
  const isNotLost = opportunityData?.Status !== "Lost";
  const isPreSalesApproved = getPreSalesTask?.[0]?.Status == "Approved";
  const isSpecialSegmentDIA = opportunityData?.ProductSegment == "DIA";

  const isSDWANWon = isNotWon &&  isPreSalesApproved && getDoaApprovedFlag;

  console.log("isNotWon" , isNotWon);
  console.log("isNotLost" , isNotLost);
  console.log("isSpecialSegmentDIA" , isSpecialSegmentDIA);
  console.log("isPreSalesApproved" , isPreSalesApproved);
  console.log("getFeasibilityApprovedFlag" , getFeasibilityApprovedFlag);
  console.log("getDoaApprovedFlag",getDoaApprovedFlag);
  

  const isNonSDWANWon = isNotWon && isNotLost &&  isPreSalesApproved && getFeasibilityApprovedFlag && getDoaApprovedFlag;
  
  const isDiaWon = isNotWon && isNotLost && isSpecialSegmentDIA && getFeasibilityApprovedFlag && getDoaApprovedFlag;

  // const canShowWonButton =
  //   isSDWAN ? isSDWANWon : isNonSDWANWon;
  const canShowWonButton = isSDWAN ? isSDWANWon : isSpecialSegmentDIA ? isDiaWon : isNonSDWANWon;

  // ====================WON button condition end =================


  // ====================== SDWAN END======================= 

  return (
    <>
      {/* ***********Header********* */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectoppPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className=" " >Business Opportunity</span>
          {opportunityData.Status.toLowerCase() == "won" && (
            OppSubSeg === "SDWAN" ? (
              <span className=" flr-createCAf" onClick={handleCreateSaf} style={{ fontSize: "10px" }}>
                Create SAF
              </span>
            ) : (
              <span className=" flr-createCAf" onClick={handleCreateCaf} style={{ fontSize: "10px" }}>
                Create CAF
              </span>
            )
          )}

          {/* {!opportunityData.FeasibilityRequired && !loading && opportunityData.Status !== "Won" && opportunityData.Building_BuildingStatus == "Non-RFS" && (
            <span className="p-1 flr-createCAf" onClick={() => generateFeasibility(OppId)} style={{ fontSize: "12px" }}>
              Generate Feasibility
            </span>
          )} */}

          {!opportunityData.FeasibilityRequired && opportunityData.Status !== "Won" && enableGenerateFeasibilityBtn && !loading && (
            <span className=" flr-createCAf" onClick={() => generateFeasibility(OppId)} style={{ fontSize: "10px", marginRight: "5px" }}>
              Generate Feasibility
            </span>
          )}

          {(opportunityData?.ProductSegment == "Managed Wi-Fi Business-S" || opportunityData?.ProductSegment == "Managed Wi-Fi Business") && opportunityData.Status !== "Won" && !loading && (
            <span className=" flr-createCAf" onClick={() => createSurveyTask(OppId)} style={{ fontSize: "10px", marginRight: "5px" }}>
              Generate Survey Task
            </span>
          )}

        </div>
      </div>

      {/* ************Header end************ */}

      {loading ? (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={load} alt="loading...."></img>
          </div>
        </div>
      ) : (
        <form>
          <div className="container-fluid mb-4 form-container">
            {/* {(getPreSalesTask[0]?.Status == "Approved" && opportunityData.Status !== "Won" && opportunityData?.Status != "Lost" && getFeasibilityApprovedFlag && getDoaApprovedFlag) && (
              <div>
                <button
                  type='button'
                  className="btn w-100 mt-2 qualify-btn text-light"
                  onClick={handleWon}
                >
                  WON
                </button>
              </div>
            )} */}

            {/* {(OppSubSeg === "SDWAN" ?
              (opportunityData.Status !== "Won" && getPreSalesTask[0]?.Status == "Approved" && getDoaApprovedFlag)
              : (getPreSalesTask[0]?.Status == "Approved" && opportunityData.Status !== "Won" && opportunityData?.Status != "Lost" && getFeasibilityApprovedFlag && getDoaApprovedFlag)) && (
                <div>
                  <button
                    type='button'
                    className="btn w-100 mt-2 qualify-btn text-light"
                    onClick={handleWon}
                  >
                    WON
                  </button>
                </div>
              )} */}

            {canShowWonButton && (
              <div>
                <button
                  type='button'
                  className="btn w-100 mt-2 qualify-btn text-light"
                  onClick={handleWon}
                >
                  WON
                </button>
              </div>
            )}

            {/* {(opportunityData.Status !== "Won") && (
              <button
                type='button'
                className="btn w-100 mt-2 qualify-btn text-light"
                onClick={handleLost}
              >
                LOST
              </button>
            )} */}

            {opportunityData.Status != "Won" &&
              <div className='mt-2'>
                <Select
                  className="basic-single disqualify-select"
                  classNamePrefix="select"
                  name="subBusiness"
                  // value={selectQualify}
                  isSearchable={false}
                  styles={customStyles}
                  value={{ value: "", label: "LOST" }} // Value should be an object with 'value' and 'label' properties
                  onChange={handleLost}
                  options={optionLost.map((data) => ({
                    value: data.code,
                    label: data.name,
                  }))}
                />
              </div>}


            {/* {console.log("opportunityData",opportunityData?.ProductSegment)} */}

            {(isSDWAN ? isSDWANCondition : isNonSDWANCondition) && isDiscountValid && (
              <>
                <button
                  type="button"
                  className="btn w-100 mt-2 qualify-btn text-light"
                  onClick={handleSendToApproval}
                >
                  Submit for Approval
                </button>
              </>)}


            {/* {(OppSubSeg === "SDWAN" ? (
              opportunityData?.ApprovalRequiredFlag === "yes" &&
              opportunityData?.Statuscode !== "Approved" &&
              opportunityData?.Statuscode !== "Won" &&
              opportunityData?.Statuscode !== "Waiting for Approval"
            ) : (getRcDiscount && getRcDiscount > 0 && getOtcDiscount && (getOtcDiscount > 0 || getOtcDiscount == 0) && opportunityData?.Status != "Lost" && opportunityData?.Statuscode !== "Waiting for Approval" && opportunityData?.Statuscode !== "Approved" && opportunityData?.Statuscode !== "Won")) && (
                <>
                  {!(parseFloat(opportunityData?.OTCAmount) <= parseFloat(getOtcDiscount) ||
                    parseFloat(opportunityData?.RCAmount) <= parseFloat(getRcDiscount)) && (
                      <button
                        type="button"
                        className="btn w-100 mt-2 qualify-btn text-light"
                        onClick={handleSendToApproval}
                      >
                        Submit for Approval
                      </button>
                    )}
                </>
              )} */}




            {/* **************Opportunity Details toggle******************* */}
            <div className="contact-toggle mt-3" onClick={() => handleIconClick("form1")}
            >
              <span className="toggle-text">Opportunity Details</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>

            {activeForm === "form1" && (
              <div className="container shadow  mb-3 bg-body rounded mt-4" id="form1">
                <fieldset className="contact-form p-2">


                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder="Mobile Phone"
                      className="form-control input-text form-control-sm mt-1"
                      id="Topic"
                      name="Topic"
                      value={opportunityData.Topic || ""}
                      onChange={handleChange}
                    />
                    <label htmlFor="mobilephone" className='mt-2'>Topic*</label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder="Opportunity ID"
                      className="form-control input-text form-control-sm mt-1"
                      id="Opportunity"
                      name="OppId"
                      value={opportunityData.OppId || ""}
                      onChange={handleChange}
                    />
                    <label htmlFor="Opportunity" className='mt-2'>Opportunity ID*</label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder="Opportunity ID"
                      className="form-control input-text form-control-sm mt-1"
                      id="Opportunity"
                      name="OppId"
                      value={opportunityData.OppStatus || ""}
                      onChange={handleChange}
                    />
                    <label htmlFor="Opportunity" className='mt-2'>Opportunity Status*</label>
                  </div>


                  <div className="">
                    <label className="select-search-label mt-1">Company*</label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="company"
                      value={selectedCompany}
                      onChange={handleCompanyChange}
                      // options={companyOptions}
                      styles={style}
                      isSearchable={true}
                      isLoading={loader}
                      placeholder="Select Company"
                      isDisabled={true}
                    />
                  </div>

                  <div className="">
                    <label className="select-search-label mt-1" htmlFor="floatingSelect"> Group* </label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      id="group"
                      name="group"
                      isDisabled={true}
                      value={selectGroup}
                      onChange={handleSelectGroup}
                      // options={groupOptions}
                      styles={style}
                      placeholder="Select Group"
                      isSearchable={true}
                      isLoading={loader}
                    />
                  </div>

                  <div className="">
                    <label className="select-search-label mt-1" htmlFor="floatingSelect" > Relationship* </label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      // options={relationshipOptions}
                      placeholder="Select Relationship"
                      value={selectRelationship}
                      onChange={handleSelectRelationship}
                      styles={style}
                      isDisabled={true}
                      isLoading={loader}
                    />

                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder="Lead Name"
                      className="form-control input-text form-control-sm mt-1"
                      id="leadname"
                      name="leadname"
                      value={opportunityData.leadname || ""}
                      onChange={handleChange}
                      readOnly
                      style={{ backgroundColor: 'transparent' }}
                    />
                    <label htmlFor="leadname" className='mt-2'>Lead Name*</label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className="form-control input-text form-control-sm mt-1"
                      id="Originating"
                      name="Originating"
                      value={opportunityData.OriginatingLead || ""}
                      onChange={handleChange}
                      readOnly
                      style={{ backgroundColor: 'transparent' }}
                    />
                    <label htmlFor="floatingInput" className='mt-2'>Originating Lead*</label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className="form-control input-text form-control-sm mt-1"
                      id="Leadid"
                      name="Leadid"
                      value={opportunityData.LeadId || ""}
                      // onChange={handleChange}
                      readOnly
                      style={{ backgroundColor: 'transparent' }}
                    />
                    <label htmlFor="floatingInput" className='mt-2'>Lead ID*</label>
                  </div>



                </fieldset>
              </div>
            )}
            {/* **************Contact Person Details toggle******************* */}
            <div className="Lead-Channel-toggle mt-3" onClick={() => handleIconClick("form2")}
            >
              <span className="toggle-text">Contact Person Details</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>

            {activeForm === "form2" && (
              <div className="container shadow mb-3 bg-body rounded mt-4" id="form2">
                <fieldset className="Lead-Channel-form p-2">

                  <div className="">
                    <label className="select-search-label mt-1">
                      Salutation*
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="Salutation"
                      placeholder="Select Salutation"
                      styles={style}
                      value={selectSolutaton}
                      isSearchable={false}
                      onChange={handleSelectSolutation}
                      options={optionSolutation.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder="Contact Person Name"
                      className="form-control input-text form-control-sm mt-1"
                      id="contactPerson"
                      name="ContactPerson"
                      value={opportunityData.ContactPerson || ""}
                      onChange={handleChange}
                    />
                    <label htmlFor="contactPerson" className='mt-2'>Contact Person Name*</label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder="Email"
                      className="form-control input-text form-control-sm mt-1"
                      id="contactEmail"
                      name="Emailaddress"
                      value={opportunityData.Emailaddress || ""}
                      onChange={handleChange}
                    />
                    <label htmlFor="contactEmail" className='mt-2'>Email*</label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder="Mobile Number"
                      className="form-control input-text form-control-sm mt-1"
                      id="contactMobile"
                      name="Mobilephone"
                      value={opportunityData.Mobilephone || ""}
                      onChange={handleChange}
                    />
                    <label htmlFor="contactMobile" className='mt-2'>Mobile Number*</label>
                  </div>


                  <div className="">
                    <label className="select-search-label mt-1">Country*</label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="Country"
                      placeholder="Select Country"
                      styles={style}
                      isSearchable={false}
                      value={{ label: "India", value: "10001" }}
                      onChange={handleSelectCountry}
                      options={optionCountry.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>

                  <div className="">
                    <label className="select-search-label mt-1">State*</label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="IndustrySeg"
                      placeholder="Select State"
                      isSearchable={false}
                      styles={style}
                      value={selectState}
                      onChange={handleSelectState}
                      options={optionState.map((data) => ({
                        value: data.code,
                        label: data.name,
                      }))}
                    />
                  </div>

                  <div className="">
                    <label className="select-search-label mt-1">City*</label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="City"
                      placeholder="Select City"
                      isSearchable
                      styles={style}
                      // value={cityType.find(
                      //   (city) => city.CityCode === selectCity.value
                      // )}
                      value={selectCity}
                      onChange={handleSelectCity}
                      options={cityType.map((data) => ({
                        value: data.CityCode,
                        label: data.CityName,
                      }))}
                    />
                  </div>

                  <div className="search-area" style={{ position: "relative" }}>
                    <label className="select-search-label mt-1">Area*</label>
                    <Select
                      options={areaList.map((area) => ({
                        value: area.AreaCode,
                        label: `${area.AreaName} (${area.AreaCode})`,
                      }))}
                      className="form-control form-control-sm p-1 custom-select"
                      placeholder="Search Area"
                      isSearchable
                      styles={style}
                      value={selectArea}
                      onChange={handleSelectArea}
                    />
                    <i
                      className="fas fa-search text-secondary"
                      style={{
                        position: "absolute",
                        right: "15px",
                        top: "63%",
                        transform: "translateY(-50%)",
                      }}
                    ></i>
                  </div>


                  <div className="search-area" style={{ position: "relative" }}>
                    <label className="select-search-label mt-1">Building Name*</label>
                    <Select
                      options={buildingList.map((building) => ({
                        value: building.BuildingCode,
                        label: `${building.BuildingName} (${building.BuildingCode})`,
                      }))}
                      className="form-control form-control-sm p-1 custom-select"
                      placeholder="Search Area"
                      isSearchable
                      styles={style}
                      value={selectBuilding}
                      onChange={(selectedOption) =>
                        setSelectBuilding(selectedOption)
                      }
                    />
                    <i
                      className="fas fa-search text-secondary"
                      style={{
                        position: "absolute",
                        right: "15px",
                        top: "63%",
                        transform: "translateY(-50%)",
                      }}
                    ></i>
                  </div>


                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder="Building Number"
                      className="form-control input-text form-control-sm mt-1"
                      id="buildingNum"
                      name="BuildingNo"
                      value={opportunityData.BuildingNo || ""}
                      onChange={handleChange}
                    />
                    <label htmlFor="buildingNum" className='mt-2'>Building No./Plot No.*</label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder="Block"
                      className="form-control input-text form-control-sm mt-1"
                      id="block"
                      name="Block"
                      value={opportunityData.Block || ""}
                      onChange={handleChange}
                    />
                    <label htmlFor="block" className='mt-2'>Block*</label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder="Floor"
                      className="form-control input-text form-control-sm mt-1"
                      id="floor"
                      name="Floor"
                      value={opportunityData.Floor || ""}
                      onChange={handleChange}
                    />
                    <label htmlFor="floor" className='mt-2'>Floor*</label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder="Pin Code"
                      className="form-control input-text form-control-sm mt-1"
                      id="pin"
                      name="PostalCode"
                      value={opportunityData.PostalCode || ""}
                      onChange={handleChange}
                    />
                    <label htmlFor="pin" className='mt-2'>Pin*</label>
                  </div>
                </fieldset>
              </div>
            )}
            {/* **************Company Details toggle******************* */}
            <div className="Company-details-toggle mt-3" onClick={() => handleIconClick("form3")}
            >
              <span className="toggle-text">Company Details</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>

            {activeForm === "form3" && (
              <div className="container shadow mb-3 bg-body rounded mt-4" id="form3">
                <fieldset className="Company-details-form p-2">
                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder="Company Name"
                      className="form-control input-text form-control-sm mt-1"
                      id="company"
                      name="Companyname"
                      value={opportunityData.Companyname || ""}
                      onChange={handleChange}
                    />
                    <label htmlFor="company" className='mt-2'>Company Name*</label>
                  </div>


                  <div className="">
                    <label className="select-search-label">
                      Firm Type*
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="selectCustomerSeg"
                      placeholder="Select"
                      styles={style}
                      value={selectedFirmType}
                      isSearchable={false}
                      onChange={handleSelectFirmType}
                      options={firmtype}
                    />
                  </div>


                  <div className="">
                    <label className="select-search-label mt-1">
                      Industry Type*
                    </label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      placeholder="Select Option"
                      id="IndustryType"
                      name="IndustryType"
                      styles={style}
                      value={selectIndustry}
                      // isDisabled={true}
                      onChange={handleIndustryChnage}
                      options={industrydropdetails.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}

                    />
                  </div>

                  {(opportunityData?.ProductSegment == "Managed Wi-Fi Business-S" || opportunityData?.ProductSegment == "Managed Wi-Fi Business") && (
                    selectIndustry?.label == "Hospitality" ? (
                      <div className="input-box form-floating">
                        <input
                          type="number"
                          placeholder="Tentative count of devices"
                          className="form-control input-text form-control-sm mt-1"
                          id="NoofRooms"
                          name="NoofRooms"
                          value={opportunitySurveyData.NoofRooms || ""}
                          onChange={formInputData}
                          required={false}
                        />
                        <label htmlFor="NoOfRooms" className="mt-2">No. of Rooms*</label>
                      </div>
                    ) : selectIndustry?.label == "Co-Living" ? (
                      <div className="input-box form-floating">
                        <input
                          type="number"
                          placeholder="Tentative count of devices"
                          className="form-control input-text form-control-sm mt-1"
                          id="NoofBeds"
                          name="NoofBeds"
                          value={opportunitySurveyData.NoofBeds || ""}
                          onChange={formInputData}
                          required={false}
                        />
                        <label htmlFor="NoOfBeds" className="mt-2">No. of Beds*</label>
                      </div>) : selectIndustry?.label == "Co-Working" ? (
                        <div className="input-box form-floating">
                          <input
                            type="number"
                            placeholder="Tentative count of devices"
                            className="form-control input-text form-control-sm mt-1"
                            id="NoofSeats"
                            name="NoofSeats"
                            value={opportunitySurveyData.NoofSeats || ""}
                            onChange={formInputData}
                            required={false}
                          />
                          <label htmlFor="NoOfBeds" className="mt-2">No. of Seats*</label>
                        </div>) : (selectIndustry?.label != "Co-Living" && selectIndustry?.label != "Co-Working" && selectIndustry?.label != "Hospitality") ? (

                          <div className="input-box form-floating">
                            <input
                              type="number"
                              placeholder="Tentative count of devices"
                              className="form-control input-text form-control-sm mt-1"
                              id="NoofUsers"
                              name="NoofUsers"
                              value={opportunitySurveyData?.NoofUsers || opportunityData?.NoofUsers}
                              onChange={formInputData}
                              required={false}
                            />
                            <label htmlFor="NoofUsers" className="mt-2">No. of Users*</label>
                          </div>) : ""
                  )}

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder="Business Segment"
                      className="form-control input-text form-control-sm mt-1"
                      id="businessSegment"
                      name="Businesssegment"
                      value={"Business"}
                      isDisabled={true}
                    />
                    <label htmlFor="businessSegment" className='mt-2'>Business Segment*</label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder="Sub Business Segment"
                      className="form-control input-text form-control-sm mt-1"
                      id="subBusinessSegment"
                      name="Subbusinesssegment"
                      value={opportunityData.Subbusinesssegment || ""}
                      isDisabled={true}
                    />
                    <label htmlFor="subBusinessSegment" className='mt-2'>Sub Business Segment*</label>
                  </div>


                  <div className="">
                    <label className="select-search-label mt-1">
                      Customer Segment*
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="selectCustomerSeg"
                      placeholder="Select"
                      styles={style}
                      value={selectCustomerSeg}
                      isSearchable={false}
                      onChange={handleSelectCustomerSeg}
                      options={optionCustomerSeg.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>

                  {OppSubSeg === "SDWAN" && (
                    <div>
                      <label className="select-search-label mt-1">Vertical*</label>
                      <Select
                        className="basic-single form-control form-control-sm p-1"
                        classNamePrefix="select"
                        name="vertical"
                        value={selectedVertical}
                        onChange={setSelectedVertical}
                        options={verticalOptions}
                        styles={style}
                        placeholder="Select Vertical"
                        isSearchable={true}
                      />
                    </div>
                  )}

                  <div className="">
                    <label className="select-search-label mt-1">
                      Account Turn Over*
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="selectTurnOver"
                      placeholder="Select Option"
                      styles={style}
                      value={selectTurnOver}
                      isSearchable={false}
                      onChange={handleSelectTurnOver}
                      options={optionTurnOver.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>


                  {/* <div className="form-floating p-2">
                  <select
                    className="form-select form-control form-control-sm"
                    id="accountTurnOver"
                    name="AccountTurnOver"
                    value={opportunityData.TurnOver || ""}
                    onChange={handleChange}
                  >
                    <option value={opportunityData.TurnOver || ""}>
                      {opportunityData.TurnOver || "Select Account Turnover"}
                    </option>
                  </select>
                  <label htmlFor="accountTurnOver">Account Turn Over*</label>
                </div> */}


                </fieldset>
              </div>
            )}

            {OppSubSeg === "SDWAN" && (
              <>

                {/* Toggle for Additional Details */}
                < div
                  className="contact-toggle mt-3"
                  onClick={() => handleIconClick("form21")}
                >
                  <span className="toggle-text">Questionnaires For SDWAN</span>
                  <span className="float-end">
                    <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                  </span>
                </div>

                {activeForm === "form21" && (
                  <div
                    className="container shadow mb-3 bg-body rounded mt-4"
                    id="form21"
                  >
                    <fieldset className="contact-form p-2">
                      {/* No. of Location - free text field */}
                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder="No. of location"
                          className="form-control input-text form-control-sm mt-1"
                          id="NoOfLocation"
                          name="NoOfLocation"
                          value={SdwanOpp.NoOfLocation}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="NoOfLocation" className="mt-2">
                          No. of location*
                        </label>
                      </div>

                      {/* Is customer using ILL services - dropdown */}
                      <div>
                        <label className="select-search-label mt-1">
                          Is customer using ILL services*
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          name="CustomerILLservices"
                          value={
                            qwertyOptions.find(
                              (option) => option.value === SdwanOpp.CustomerILLservices
                            ) || qwertyOptions[0]
                          }
                          onChange={(option) =>
                            handleSelectChange("CustomerILLservices", option)
                          }
                          options={qwertyOptions}
                          styles={style}
                          placeholder="Select Option"
                          isSearchable={true}
                        />
                      </div>

                      {/* No. of Links for ILL services - free text field */}
                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder="Please mention No. of Links"
                          className="form-control input-text form-control-sm mt-1"
                          id="NumberOfLinksIll"
                          name="NumberOfLinksIll"
                          value={SdwanOpp.NumberOfLinksIll}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="NumberOfLinksIll" className="mt-2">
                          Please mention No. of Links*
                        </label>
                      </div>

                      {/* Is customer using Broadband services - dropdown */}
                      <div>
                        <label className="select-search-label mt-1">
                          Is customer using Broadband services*
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          name="CustomerBroadbandServices"
                          value={
                            qwertyOptions.find(
                              (option) => option.value === SdwanOpp.CustomerBroadbandServices
                            ) || qwertyOptions[0]
                          }
                          onChange={(option) =>
                            handleSelectChange("CustomerBroadbandServices", option)
                          }
                          options={qwertyOptions}
                          styles={style}
                          placeholder="Select Option"
                          isSearchable={true}
                        />
                      </div>

                      {/* No. of Links for Broadband services - free text field */}
                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder="Please mention No. of Links"
                          className="form-control input-text form-control-sm mt-1"
                          id="NumberOfLinksBroadbandServices"
                          name="NumberOfLinksBroadbandServices"
                          value={SdwanOpp.NumberOfLinksBroadbandServices}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="NumberOfLinksBroadbandServices" className="mt-2">
                          Please mention No. of Links*
                        </label>
                      </div>

                      {/* Are these links being managed - dropdown */}
                      <div>
                        <label className="select-search-label mt-1">
                          Are these links being managed links*
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          name="LinksManagedLinks"
                          value={
                            qwertyOptions.find(
                              (option) => option.value === SdwanOpp.LinksManagedLinks
                            ) || qwertyOptions[0]
                          }
                          onChange={(option) =>
                            handleSelectChange("LinksManagedLinks", option)
                          }
                          options={qwertyOptions}
                          styles={style}
                          placeholder="Select Option"
                          isSearchable={true}
                        />
                      </div>

                      {/* Is customer using any Routing services - dropdown */}
                      <div>
                        <label className="select-search-label mt-1">
                          Is customer using any Routing services*
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          name="CustomerRoutingServices"
                          value={
                            qwertyOptions.find(
                              (option) => option.value === SdwanOpp.CustomerRoutingServices
                            ) || qwertyOptions[0]
                          }
                          onChange={(option) =>
                            handleSelectChange("CustomerRoutingServices", option)
                          }
                          options={qwertyOptions}
                          styles={style}
                          placeholder="Select Option"
                          isSearchable={true}
                        />
                      </div>

                      {/* When is the Firewall set to expire - calendar */}
                      <div className="input-box form-floating">
                        <input
                          type="date"
                          placeholder="When is the Firewall set to expire"
                          className="form-control input-text form-control-sm mt-1"
                          id="FirewallSetToExpire"
                          name="FirewallSetToExpire"
                          value={convertToISOFormat(SdwanOpp.FirewallSetToExpire)}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="FirewallSetToExpire" className="mt-2">
                          When is the Firewall set to expire*
                        </label>
                      </div>

                      {/* Indication of IT Spent - free text field */}
                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder="Indication of IT Spent"
                          className="form-control input-text form-control-sm mt-1"
                          id="IndicationITSpent"
                          name="IndicationITSpent"
                          value={SdwanOpp.IndicationITSpent}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="IndicationITSpent" className="mt-2">
                          Indication of IT Spent*
                        </label>
                      </div>

                      {/* Current Operational City - dropdown */}
                      <div className="">
                        <label className="select-search-label mt-1">
                          Current Operational City*
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          name="CurrentOperationalCity"
                          placeholder="Select City"
                          styles={style}
                          value={selectCurrentWorkLocation}
                          isSearchable={true}
                          onChange={handleCurrentWorkLocation}
                          options={currentWorkLocations.map((data) => ({
                            value: data.value,
                            label: data.label,
                          }))}
                        />
                      </div>

                      {/* Network Security Services used by customer - dropdown */}
                      <div>
                        <label className="select-search-label mt-1">
                          Network Security Services used by customer*
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          name="NetworkSecurityServices"
                          value={
                            qwertyOptions.find(
                              (option) => option.value === SdwanOpp.NetworkSecurityServices
                            ) || qwertyOptions[0]
                          }
                          onChange={(option) =>
                            handleSelectChange("NetworkSecurityServices", option)
                          }
                          options={qwertyOptions}
                          styles={style}
                          placeholder="Select Option"
                          isSearchable={true}
                        />
                      </div>

                      {/* Where are the Applications Hosted - dropdown */}
                      <div>
                        <label className="select-search-label mt-1">
                          Where are the Applications Hosted*
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          name="ApplicationsHosted"
                          value={
                            qwertyOptions.find(
                              (option) => option.value === SdwanOpp.ApplicationsHosted
                            ) || qwertyOptions[0]
                          }
                          onChange={(option) =>
                            handleSelectChange("ApplicationsHosted", option)
                          }
                          options={qwertyOptions}
                          styles={style}
                          placeholder="Select Option"
                          isSearchable={true}
                        />
                      </div>

                      {/* IT support for the customer - dropdown */}
                      <div>
                        <label className="select-search-label mt-1">
                          IT support for the customer*
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          name="ItSupport"
                          value={
                            qwertyOptions.find(
                              (option) => option.value === SdwanOpp.ItSupport
                            ) || qwertyOptions[0]
                          }
                          onChange={(option) =>
                            handleSelectChange("ItSupport", option)
                          }
                          options={qwertyOptions}
                          styles={style}
                          placeholder="Select Option"
                          isSearchable={true}
                        />
                      </div>

                      {/* Is there any redundancy for MPLS - dropdown */}
                      <div>
                        <label className="select-search-label mt-1">
                          Is there any redundancy for MPLS*
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          name="RedundancyMPLS"

                          value={
                            qwertyOptions.find(
                              (option) => option.value === SdwanOpp.RedundancyMPLS
                            ) || qwertyOptions[0]
                          }
                          onChange={(option) =>
                            handleSelectChange("RedundancyMPLS", option)
                          }
                          options={qwertyOptions}
                          styles={style}
                          placeholder="Select Option"
                          isSearchable={true}
                        />
                      </div>

                      {/* Is there existing MPLS backbone - dropdown */}
                      <div>
                        <label className="select-search-label mt-1">
                          Is there existing MPLS backbone*
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          name="MPLSBackbone"
                          value={
                            qwertyOptions.find(
                              (option) => option.value === SdwanOpp.MPLSBackbone
                            ) || qwertyOptions[0]
                          }
                          onChange={(option) =>
                            handleSelectChange("MPLSBackbone", option)
                          }
                          options={qwertyOptions}
                          styles={style}
                          placeholder="Select Option"
                          isSearchable={true}
                        />
                      </div>

                      {/* When is the MPLS contract to be renewed? - calendar */}
                      <div className="input-box form-floating">
                        <input
                          type="date"
                          placeholder="When is the MPLS contract to be renewed?"
                          className="form-control input-text form-control-sm mt-1"
                          id="MPLSContract"
                          name="MPLSContract"
                          value={convertToISOFormat(SdwanOpp.MPLSContract)}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="MPLSContract" className="mt-2">
                          When is the MPLS contract to be renewed?*
                        </label>
                      </div>

                      {/* Remarks - free text field */}
                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder="Remarks"
                          className="form-control input-text form-control-sm mt-1"
                          id="SdwanRemarks"
                          name="SdwanRemarks"
                          value={SdwanOpp.SdwanRemarks}
                          onChange={handleInputChange}
                        />
                        <label htmlFor="SdwanRemarks" className="mt-2">
                          Remarks
                        </label>
                      </div>
                    </fieldset>
                  </div>
                )}


                {/* Toggle for Additional Details */}
                < div
                  className="contact-toggle mt-3"
                  onClick={() => handleIconClick("form22")}
                >
                  <span className="toggle-text">Site Details</span>
                  <span className="float-end">
                    <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                  </span>
                </div>

                {activeForm === "form22" && (
                  <div
                    className="container shadow mb-3 bg-body rounded mt-4"
                    id="form22"
                  >
                    <fieldset className="contact-form p-2">
                      {/* No. of location - free text field */}
                      <div className="d-flex justify-content-center gap-1">
                        <button
                          type="button"
                          className="btn text-light etr-btn bg-dark mx-auto rounded-pill"
                          style={{
                            width: "90px",
                            fontSize: "16px",
                            padding: "6px",
                            fontWeight: "bold",
                          }}
                          onClick={handleAddSite}
                        >
                          Add Site
                        </button>
                      </div>

                      <fieldset className="Remarks-form p-2">
                        <div className="input-box form-floating">
                          <div className="input-box form-floating p-3 select-search-label">
                            {getSiteDetailsData?.length > 0 ? getSiteDetailsData?.map((data, index) => (
                              <div className="input-box form-floating p-2" key={index}
                              >
                                <Link
                                  to={`/businessSitedetails?SiteID=${data?.SiteID}`}
                                  style={{ textDecoration: 'none', color: 'inherit' }}
                                >
                                  <strong>Site ID: {data?.SiteID || "NA"}</strong>
                                  <div>Solution Deployment Mode: {data?.SolutionDeploymentMode || "NA"}</div>
                                  <div>Site Category: {data?.SiteCategory || "NA"}</div>
                                  <div>Site Type: {data?.SiteType || "NA"}</div>
                                  <div>Site Status: {data?.SiteStatus || "NA"}</div>
                                </Link>


                              </div>
                            )) : <div>No Sites found.</div>}

                          </div>
                        </div>
                      </fieldset>
                    </fieldset>
                  </div>
                )}




              </>
            )}

            <div
              className="Other-details-toggle mt-3"
              onClick={() => handleIconClick("form4")}
            >
              <span className="toggle-text">Other Details</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>
            {activeForm === "form4" && (
              <div
                className="container shadow mb-3 bg-body rounded mt-4"
                id="form4"
              >
                <fieldset className="Remarks-form p-2" >

                  <div className="Other-details-toggle mt-3">
                    <form className="Other-details-form p-2">
                      <div className="">
                        <label htmlFor="floatingSelect" className='select-search-label'>
                          Media*
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          name="media"
                          placeholder="Select Media"
                          styles={style}
                          value={selectedMedia}
                          // defaultValue={}
                          isSearchable={false}
                          onChange={handleSelectMedia}
                          options={media.map((data) => ({
                            value: data.value,
                            label: data.label,
                          }))}
                        />
                      </div>

                      <div className="input-box form-floating mt-1">
                        <input
                          type="text"
                          placeholder=""
                          className=" form-control input-text form-control-sm"
                          id="firewall"
                          name="UpTimesla"
                          value={opportunityData.UpTimesla || ""}
                          onChange={handleChange}
                        />
                        <label htmlFor="floatingInput" className='mt-2'>Uptime SLA Committed (%)*</label>
                      </div>

                      <div className="">
                        <label htmlFor="floatingSelect" className='select-search-label mt-1'>
                          Existing Service Provider*
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          name="service"
                          placeholder="Select Service Provider"
                          styles={style}
                          value={selectExServiceProvider1}
                          isSearchable={false}
                          onChange={handleSelectServiceProvider1}
                          options={ExServiceProvider.map((data) => ({
                            value: data.value,
                            label: data.label,
                          }))}
                        />

                      </div>
                      <div className="">
                        <label htmlFor="floatingSelect" className='select-search-label mt-1'>
                          Firewall (if Any)*
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          name="firewall"
                          placeholder="Select Option"
                          styles={style}
                          value={selectInterestedFirewall}
                          isSearchable={false}
                          onChange={handleInterestedFirewall}
                          options={optionInterestedFirewall.map((data) => ({
                            value: data.value,
                            label: data.label,
                          }))}
                        />

                      </div>

                      {selectInterestedFirewall?.value == "1" &&
                        <div className="input-box form-floating mt-1">
                          <input
                            type="date"
                            placeholder=""
                            className=" form-control input-text form-control-sm"
                            id="date"
                            name="FirewallAMCExpiryDate"
                            onChange={handleChange}
                            value={yyyymmddFormat(opportunityData.FirewallAMCExpiryDate)}
                          />
                          <label htmlFor="floatingInput" className="p-2">Firewall AMC Expiry Date*</label>
                        </div>}

                      <div className="">
                        <label htmlFor="floatingSelect" className='select-search-label mt-1'>
                          Redundancy Required
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          name="redundancy"
                          placeholder="Select Option"
                          styles={style}
                          value={selectInterestedVPN}
                          isSearchable={false}
                          isDisabled={isRedundancyLocked}
                          onChange={handleInterestedVPN}
                          options={optionInterestedVPN.map((data) => ({
                            value: data.value,
                            label: data.label,
                          }))}
                        />

                      </div>

                      <div className="">
                        <label htmlFor="floatingSelect" className='select-search-label mt-1'>
                          Company Self PO(ERP)*
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          name="companySelf"
                          placeholder="Select Option"
                          styles={style}
                          // value={selectInterestedManageWiFi}
                          value={selectInterestedManageWiFi}
                          isSearchable={false}
                          onChange={handleInterestedManageWiFi}
                          options={optionInterestedManageWiFi.map((data) => ({
                            value: data.value,
                            label: data.label,
                          }))}
                        />

                      </div>

                      <div className="input-box form-floating ">
                        <input
                          type="date"
                          placeholder=""
                          className=" form-control input-text form-control-sm mt-1"
                          id="date"
                          name="PoLock"
                          onChange={handleChange}
                          value={yyyymmddFormat(opportunityData.PoLock)}
                        />
                        <label htmlFor="floatingInput" className="mt-2">PO Lock In Duration*</label>
                      </div>

                      <div className="input-box form-floating ">
                        <input
                          type="date"
                          placeholder=""
                          className="form-control input-text form-control-sm mt-1"
                          id="date"
                          name="PoNext"
                          onChange={handleChange}
                          value={(yyyymmddFormat(opportunityData.PoNext))}
                          min={minPoNext}
                          disabled={!opportunityData.PoLock}
                          style={{ backgroundColor: 'transparent' }}
                        />
                        <label htmlFor="floatingInput" className="mt-2">PO Next Renewal Data*</label>
                      </div>

                    </form>
                  </div>
                </fieldset>
              </div>
            )}

            {OppSubSeg !== "SDWAN" && (
              <>
                <div className="Remarks-toggle mt-3" onClick={() => handleIconClick("form5")}
                >
                  <span className="toggle-text">Product Details</span>
                  <span className=" float-end">
                    <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                  </span>
                </div>

                {activeForm === "form5" && (
                  <div className="container shadow mb-3 bg-body rounded mt-4" id="form5">
                    <fieldset className="Remarks-form p-2">

                      <div className="Other-details-toggle mt-3">
                        <form className="Other-details-form p-2">

                          <div className="">
                            <label className="select-search-label mt-1">
                              Price list*
                            </label>
                            <Select
                              className=" basic-single form-control form-control-sm p-1"
                              classNamePrefix="select"
                              name="Price"
                              placeholder="Select Price List"
                              styles={style}
                              value={selectedPriceList}
                              isSearchable={true}
                              onChange={handlePriceListChange}
                              options={priceListOptions.map((data) => ({
                                value: data.value,
                                label: data.label,
                              }))}
                            />
                          </div>

                          <div className="search-area" style={{ position: "relative" }}>
                            <label className="select-search-label mt-1">
                              Product list*
                            </label>
                            <Select
                              className=" basic-single form-control form-control-sm p-1"
                              classNamePrefix="select"
                              name="Product"
                              placeholder="Select Product"
                              styles={style}
                              value={selectedProduct}
                              isSearchable={true}
                              onChange={handleProductChange}
                              options={productOptions.map((data) => ({
                                value: data.value,
                                label: data.label,
                              }))}
                            />
                            {selectedProduct?.value &&
                              <i
                                className="fa fa-trash"
                                onClick={() => deleteOppProduct(null)}
                                style={{
                                  position: "absolute",
                                  right: "15px",
                                  top: "63%",
                                  transform: "translateY(-50%)",
                                }}
                              ></i>}
                          </div>

                          {/* Product list*

                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <Select
                            className=" basic-single form-control form-control-sm p-1"
                            classNamePrefix="select"
                            name="Product"
                            placeholder="Select Product"
                            styles={style}
                            value={selectedProduct}
                            isSearchable={true}
                            onChange={handleProductChange}
                            options={productOptions.map((data) => ({
                              value: data.value,
                              label: data.label,
                            }))}
                          />
                          <i
                            className="fa fa-trash"
                            onClick={() => deleteOppProduct(null)}
                            style={{
                              position: "absolute",
                              right: "72px",
                              top: "56%",
                              transform: "translateY(-50%)",
                            }}
                          ></i>
                        </div>

                       
                      </div> */}


                          {getIpProd?.length > 0 && (
                            <div className="input-box form-floating">
                              <input
                                type="number"
                                placeholder="Enter SD Amount"
                                className="form-control input-text form-control-sm mt-2"
                                id="ipDiscount"
                                name="ipDiscount"
                                value={String(opportunityData.ipDiscount) || ""}
                                onChange={handleChange}
                                onBlur={discountInput}
                                disabled={!discountFlag == "IPADDRESS"}
                                style={{ background: "transparent" }}
                              />
                              <label htmlFor="sdAmount" className="mt-2">IP Discount</label>
                            </div>
                          )}

                          <div className="input-box form-floating">
                            <input
                              type="text"
                              placeholder="Enter reason"
                              className="form-control input-text form-control-sm mt-1"
                              id="reason"
                              name="Reason"
                              value={opportunityData.Reason || "NA"}
                              onChange={handleChange}
                              readOnly
                              style={{ background: "transparent" }}
                            />
                            <label htmlFor="reason" className="mt-2">Reason</label>
                          </div>

                          <div className="input-box form-floating">
                            <input
                              type="number"
                              placeholder="Enter OTC Amount"
                              className="form-control input-text form-control-sm mt-1"
                              id="otcAmount"
                              name="OTCAmount"
                              value={String(opportunityData.OTCAmount) || ""}
                              onChange={handleChange}
                              onBlur={discountInput}
                              // disabled
                              style={{ background: "transparent" }}
                            />
                            <label htmlFor="otcAmount" className="mt-2">OTC Amount</label>
                          </div>

                          <div className="input-box form-floating">
                            <input
                              type="number"
                              placeholder="Enter SD Amount"
                              className="form-control input-text form-control-sm mt-2"
                              id="otcDiscount"
                              name="otcDiscount"
                              value={String(opportunityData.otcDiscount) || ""}
                              onChange={handleChange}
                              onBlur={discountInput}
                              disabled={!discountFlag == "OTC"}
                              style={{ background: "transparent" }}
                            />
                            <label htmlFor="sdAmount" className="mt-2">OTC Discount</label>
                          </div>

                          <div className="input-box form-floating">
                            <input
                              type="text"
                              placeholder="Enter SD Amount"
                              className="form-control input-text form-control-sm mt-2"
                              id="discount"
                              name="discount"
                              value={opportunityData.exOtcDiscount || "NA"}
                              onChange={handleChange}
                              disabled
                              style={{ background: "transparent" }}
                            />
                            <label htmlFor="sdAmount" className="mt-2">Extended OTC Amount</label>
                          </div>

                          {/* <div className="input-box form-floating">
                      <input
                        type="number"
                        placeholder="Enter SD Amount"
                        className="form-control input-text form-control-sm mt-2"
                        id="sdAmount"
                        name="SDAmount"
                        value={opportunityData.SDAmount || ""}
                        onChange={handleChange}
                        disabled
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="sdAmount" className="mt-2">SD Amount</label>
                    </div> */}



                          <div className="input-box form-floating">
                            <input
                              type="number"
                              placeholder="Enter RC Amount"
                              className="form-control input-text form-control-sm mt-1"
                              id="rcAmount"
                              name="RCAmount"
                              value={String(opportunityData.RCAmount) || ""}
                              onChange={handleChange}
                              onBlur={discountInput}
                              // disabled
                              style={{ background: "transparent" }}
                            />
                            <label htmlFor="rcAmount" className="mt-2">RC Amount</label>
                          </div>


                          <div className="input-box form-floating">
                            <input
                              type="number"
                              placeholder="Enter SD Amount"
                              className="form-control input-text form-control-sm mt-2"
                              id="sdDiscount"
                              name="rcDiscount"
                              value={String(opportunityData.rcDiscount) || ""}
                              onChange={handleChange}
                              onBlur={discountInput}
                              disabled={!discountFlag == "RC"}
                              style={{ background: "transparent" }}
                            />
                            <label htmlFor="sdAmount" className="mt-2">RC Discount</label>
                          </div>

                          <div className="input-box form-floating">
                            <input
                              type="text"
                              placeholder="Enter SD Amount"
                              className="form-control input-text form-control-sm mt-2"
                              id="discount"
                              name="exRcDiscount"
                              value={opportunityData.exRcDiscount || "NA"}
                              onChange={handleChange}
                              disabled
                              style={{ background: "transparent" }}
                            />
                            <label htmlFor="sdAmount" className="mt-2">Extended RC Amount</label>
                          </div>
                        </form>
                      </div>

                    </fieldset>
                  </div>)}
              </>
            )}

            {/* <div className="Remarks-toggle mt-3" onClick={() => handleIconClick("form12")}
            >
              <span className="toggle-text">Quote Details</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div> */}


            {activeForm === "form12" && (
              <div className="container shadow mb-3 bg-body rounded mt-4" id="form12">
                <fieldset className="Remarks-form p-2">
                  <div className="Other-details-toggle mt-3">
                    {/* <div className='mb-4'>
                      <button
                        type='button'
                        className="btn w-100 mt-2 qualify-btn text-light"
                        onClick={handleAddQuote}
                      >
                        Add Quote
                      </button>
                    </div> */}
                    <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                      {allQuoteData && allQuoteData?.length > 0 ? (
                        allQuoteData.map((data, index) => (
                          <div className="col" key={index}>
                            <div className="card mb-3">
                              <div className="m-3 card-data" style={{ display: "inline-flex" }} >
                                <div>
                                  <p className="caf-card-text">Quote Id : {data.Quoteid}</p>
                                  <p className="caf-card-text">Total Amount : {data.TotalAmount}</p>
                                  <p className="caf-card-text">Opportunity Name : {data.OpportunityName}</p>
                                  <p className="caf-card-text">Status : {data.Status}</p>
                                  <p className="caf-card-text">Status Reason : {data.StatusReason}</p>
                                </div>
                              </div>
                              <div className="d-flex justify-content-center gap-2 p-2">
                                <button type="button" className="btn qualify-btn text-light w-50" onClick={() => handleWonQoute(data.Quoteid)}>
                                  Won
                                </button>
                                <button type="button" className="btn qualify-btn text-light w-50" onClick={() => handleLostQoute(data.Quoteid)}>
                                  Lost
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="col-12 text-center">
                          <p>No data available.</p>
                        </div>
                      )}
                    </div>



                  </div>
                </fieldset>
              </div>)}



            {(opportunityData?.ProductSegment == "Managed Wi-Fi Business-S" || opportunityData?.ProductSegment == "Managed Wi-Fi Business") &&
              getPreSalesTask[0]?.MeetingDoneWithCustomer == "Yes" && (
                <div
                  className="Remarks-toggle mt-3"
                  onClick={() => handleIconClick("SurveyDetails")}
                >
                  <span className="toggle-text">Survey Details</span>
                  <span className=" float-end">
                    <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                  </span>
                </div>
              )}

            {activeForm === "SurveyDetails" && (
              <div>
                <div className="container shadow mb-3 bg-body rounded mt-4" id="form7" >
                  {/* <BusinessOppotunitySurveyForm OppId={OppId} formInputData={formInputWifi} opportunitySurveyData={opportunityDataWifi}/> */}
                  <fieldset className="contact-form p-1">
                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder="Mobile Phone"
                        className="form-control input-text form-control-sm mt-1"
                        id="SiteName"
                        name="SiteName"
                        value={opportunitySurveyData.SiteName || ""}
                        onChange={formInputData}
                      />
                      <label htmlFor="mobilephone" className='mt-2'>Site Name*</label>
                    </div>

                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder="Mobile Phone"
                        className="form-control input-text form-control-sm mt-1"
                        id="CustomerContactName"
                        name="CustomerContactName"
                        max="10"
                        value={opportunitySurveyData.CustomerContactName || ""}
                        onChange={formInputData}
                      />
                      <label htmlFor="mobilephone" className='mt-2'>Customer Contact Name*</label>
                    </div>

                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder="Mobile Phone"
                        className="form-control input-text form-control-sm mt-1"
                        id="CustomerContactNumber"
                        name="CustomerContactNumber"
                        value={opportunitySurveyData?.CustomerContactNumber || ""}
                        onChange={formInputData}
                        onInput={(e) => {
                          e.target.value = e.target.value.slice(0, 10); // Prevents input beyond 10 digits
                        }}
                        pattern="[0-9]{10}" // Ensures only numbers
                        inputMode="numeric" // Mobile-friendly numeric keyboard
                      />
                      <label htmlFor="mobilephone" className='mt-2'>Customer Contact Number*</label>
                    </div>
                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder="Mobile Phone"
                        className="form-control input-text form-control-sm mt-1"
                        id="Customeremailidsitespoc"
                        name="Customeremailidsitespoc"
                        value={opportunitySurveyData?.Customeremailidsitespoc || ""}
                        onChange={formInputData}
                      />
                      <label htmlFor="mobilephone" className='mt-2'>Customer Email ID*</label>
                    </div>

                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder="Mobile Phone"
                        className="form-control input-text form-control-sm mt-1"
                        id="ListofBuildings"
                        name="ListofBuildings"
                        value={opportunitySurveyData.ListofBuildings || ""}
                        onChange={formInputData}
                      />
                      <label htmlFor="mobilephone" className='mt-2 upfont-textStyle'>List of Buildings/Blocks/Floors to be covered*</label>
                    </div>

                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder="Area to be Covered (in Sq. Ft)"
                        className="form-control input-text form-control-sm mt-1"
                        id="AreaToBeCovered"
                        name="AreatobeCovered"
                        value={opportunitySurveyData.AreatobeCovered || ""}
                        onChange={formInputData}
                      />
                      <label htmlFor="AreaToBeCovered" className="mt-2">Area to be Covered (in Sq. Ft)</label>
                    </div>

                    <div className="">
                      <label className="select-search-label mt-1">
                        Building and Floor Plan*
                      </label>
                      <Select
                        className=" basic-single form-control form-control-sm p-1"
                        classNamePrefix="select"
                        id="BuildingFloorPlan"
                        name="BuildingandFloorPlan"
                        placeholder="Select Building and Floor Plan"
                        styles={style}
                        value={getBuildingAndFloorPlanOptions?.find((data) => data?.value == opportunitySurveyData?.BuildingandFloorPlan)}
                        // value={selectedDropdownObj?.BuildingandFloorPlan} // Set the value based on your state
                        onChange={(selectedOption) => formDropdownInput("BuildingandFloorPlan", selectedOption?.value)}
                        options={getBuildingAndFloorPlanOptions}
                      // isDisabled={disableFileds}
                      />
                    </div>

                    {opportunitySurveyData?.BuildingandFloorPlan == "111260000" && (
                      <div className="input-box form-floating">
                        <input
                          type="file"
                          name="BuildingFloorAttachment"
                          accept=".pdf, .jpg, .jpeg, .png"
                          className="form-control input-text form-control-sm"
                          onChange={formInputData}
                        />
                        {/* <p className="">{opportunitySurveyData?.BuildingFloorAttachment?.FileNameWithExtension}</p> */}

                        <i
                          className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                        ></i>
                      </div>
                    )}

                    <div className="">
                      <label className="select-search-label mt-1">
                        Network Security Required?
                      </label>
                      <Select
                        className="basic-single form-control form-control-sm p-1"
                        classNamePrefix="select"
                        id="NetworkSecurity"
                        name="NetworkSecurityrequired"
                        placeholder="Select Network Security"
                        styles={style}
                        value={getNetworkSecurityRequiredOptions?.find((data) => data.value == opportunitySurveyData?.NetworkSecurityrequired)}
                        // value={selectedDropdownObj?.NetworkSecurity}
                        onChange={(selectedOption) => formDropdownInput("NetworkSecurityrequired", selectedOption?.value)}
                        options={getNetworkSecurityRequiredOptions}
                      />
                    </div>

                    {(getNetworkSecurityRequiredOptions?.find((data) => data?.value == opportunitySurveyData?.NetworkSecurityrequired)?.label == "Firewall" ||
                      getNetworkSecurityRequiredOptions?.find((data) => data?.value == opportunitySurveyData?.NetworkSecurityrequired)?.label == "UTM") &&
                      (<div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder="Specific Security Features Required"
                          className="form-control input-text form-control-sm mt-1"
                          id="SecurityFeatures"
                          name="Anyspecificsecurity"
                          value={opportunitySurveyData.Anyspecificsecurity || ""}
                          onChange={formInputData}
                        />
                        <label htmlFor="SecurityFeatures" className="mt-2 upfont-textStyle">Any Specific Security Features Required?</label>
                      </div>)}

                    <div className="">
                      <label className="select-search-label mt-1">
                        Existing Network Security Device?
                      </label>
                      <Select
                        className="basic-single form-control form-control-sm p-1"
                        classNamePrefix="select"
                        id="ExistingNetworkSecurityDevice"
                        name="ExistingNetworkSecurityDevice"
                        placeholder="Select Existing Network Security Device"
                        styles={style}
                        value={getExistingNetworkSecurityDeviceOptions?.find((data) => data.value == opportunitySurveyData?.ExistingNetworkSecurityDevice)}
                        // value={selectedDropdownObj?.ExistingNetworkSecurityDevice}
                        onChange={(selectedOption) => formDropdownInput("ExistingNetworkSecurityDevice", selectedOption?.value)}
                        options={getExistingNetworkSecurityDeviceOptions}
                      />
                    </div>




                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder="Make/Model of Existing Security Device"
                        className="form-control input-text form-control-sm mt-1"
                        id="MakeModelofexisting"
                        name="MakeModelofexisting"
                        value={opportunitySurveyData.MakeModelofexisting || ""}
                        onChange={formInputData}
                      />
                      <label htmlFor="MakeModelofexisting" className="mt-2 upfont-textStyle">Make/Model of Existing Security Device</label>
                    </div>

                    <div className="">
                      <label className="select-search-label mt-1">
                        Bandwidth Required?
                      </label>
                      <Select
                        className="basic-single form-control form-control-sm p-1"
                        classNamePrefix="select"
                        id="BandwidthRequired"
                        name="BandwidthRequired"
                        placeholder="Select Bandwidth Required"
                        styles={style}
                        // value={selectedDropdownObj?.BandwidthRequired}
                        value={getBandwidthRequiredOptions?.find((data) => data.value == opportunitySurveyData?.BandwidthRequired)}
                        onChange={(selectedOption) => formDropdownInput("BandwidthRequired", selectedOption?.value)}
                        options={getBandwidthRequiredOptions}
                      />
                    </div>

                    {getBandwidthRequiredOptions?.find((data) => data.value == opportunitySurveyData?.BandwidthRequired)?.label == "No" &&
                      (<div className="">
                        <label className="select-search-label mt-1">
                          Count of existing internet links
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          id="Countofexistinginternetlinks"
                          name="Countofexistinginternetlinks"
                          placeholder="Select Bandwidth Type"
                          styles={style}
                          // value={selectedDropdownObj?.BandwidthRequired}
                          value={getCountOfExistingInternetLinksOptions?.find((data) => data.value == opportunitySurveyData?.Countofexistinginternetlinks)}
                          onChange={(selectedOption) => formDropdownInput("Countofexistinginternetlinks", selectedOption?.value)}
                          options={getCountOfExistingInternetLinksOptions}
                        />
                      </div>)}

                    {(opportunitySurveyData?.Countofexistinginternetlinks == "111260000" || opportunitySurveyData?.Countofexistinginternetlinks == "111260001") && getBandwidthRequiredOptions?.find((data) => data.value == opportunitySurveyData?.BandwidthRequired)?.label == "No" && (
                      <>
                        <div className="input-box form-floating">
                          <input
                            type="text"
                            placeholder="Tentative count of devices"
                            className="form-control input-text form-control-sm mt-1"
                            id="ISPofexistinginternetLink1"
                            name="ISPofexistinginternetLink1"
                            value={opportunitySurveyData.ISPofexistinginternetLink1 || ""}
                            onChange={formInputData}
                          />
                          <label htmlFor="TentativeDeviceCount" className="mt-2">ISP of existing internet Link 1</label>
                        </div>

                        <div className="">
                          <label className="select-search-label mt-1">
                            Type of existing internet Link 1
                          </label>
                          <Select
                            className="basic-single form-control form-control-sm p-1"
                            classNamePrefix="select"
                            id="TypeofexistinginternetLink1"
                            name="TypeofexistinginternetLink1"
                            placeholder="Select IoT Devices Connection"
                            styles={style}
                            value={getTypeOfExistingInternetLinkOptions?.find((data) => data.value == opportunitySurveyData?.TypeofexistinginternetLink1)}
                            onChange={(selectedOption) => formDropdownInput("TypeofexistinginternetLink1", selectedOption.value)}
                            options={getTypeOfExistingInternetLinkOptions}
                          />
                        </div>

                        <div className="input-box form-floating">
                          <input
                            type="number"
                            placeholder="Tentative count of devices"
                            className="form-control input-text form-control-sm mt-1"
                            id="BandwidthoFexistinginternetLinkMbps1"
                            name="BandwidthoFexistinginternetLinkMbps1"
                            value={opportunitySurveyData.BandwidthoFexistinginternetLinkMbps1 || ""}
                            onChange={formInputData}
                          />
                          <label htmlFor="TentativeDeviceCount" className="mt-2">Bandwidth of existing internet Link (Mbps) 1</label>
                        </div>
                      </>
                    )}


                    {(opportunitySurveyData?.Countofexistinginternetlinks == "111260001" && getBandwidthRequiredOptions?.find((data) => data.value == opportunitySurveyData?.BandwidthRequired)?.label == "No") && (
                      <>
                        <div className="input-box form-floating">
                          <input
                            type="text"
                            placeholder="Enter ISP of existing internet Link 2"
                            className="form-control input-text form-control-sm mt-1"
                            id="ISPofexistinginternetLink2"
                            name="ISPofexistinginternetLink2"
                            value={opportunitySurveyData.ISPofexistinginternetLink2 || ""}
                            onChange={formInputData}
                          />
                          <label htmlFor="TentativeDeviceCount" className="mt-2">ISP of existing internet Link 2</label>
                        </div>

                        <div className="">
                          <label className="select-search-label mt-1">
                            Type of existing internet Link 2
                          </label>
                          <Select
                            className="basic-single form-control form-control-sm p-1"
                            classNamePrefix="select"
                            id="TypeofexistinginternetLink2"
                            name="TypeofexistinginternetLink2"
                            placeholder="Select Type of existing internet Link 2"
                            styles={style}
                            value={getTypeOfExistingInternetLinkOptions?.find((data) => data.value == opportunitySurveyData?.TypeofexistinginternetLink2)}
                            onChange={(selectedOption) => formDropdownInput("TypeofexistinginternetLink2", selectedOption.value)}
                            options={getTypeOfExistingInternetLinkOptions}
                          />
                        </div>

                        <div className="input-box form-floating">
                          <input
                            type="number"
                            placeholder="Enter Bandwidth of existing internet Link"
                            className="form-control input-text form-control-sm mt-1"
                            id="BandwidthoFexistinginternetLinkMbps2"
                            name="BandwidthoFexistinginternetLinkMbps2"
                            value={opportunitySurveyData.BandwidthoFexistinginternetLinkMbps2 || ""}
                            onChange={formInputData}
                          />
                          <label htmlFor="TentativeDeviceCount" className="mt-2">Bandwidth of existing internet Link (Mbps) 2</label>
                        </div>
                      </>
                    )}


                    {getBandwidthRequiredOptions?.find((data) => data.value == opportunitySurveyData?.BandwidthRequired)?.label == "Yes" &&
                      (<div className="">
                        <label className="select-search-label mt-1">
                          Bandwidth Type?
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          id="BandwidthType"
                          name="BandwidthType"
                          placeholder="Select Bandwidth Type"
                          styles={style}
                          // value={selectedDropdownObj?.BandwidthRequired}
                          value={getBandwidthTypeOptions?.find((data) => data.value == opportunitySurveyData?.BandwidthType)}
                          onChange={(selectedOption) => formDropdownInput("BandwidthType", selectedOption?.value)}
                          options={getBandwidthTypeOptions}
                        />
                      </div>)}

                    {(getBandwidthTypeOptions?.find((data) => data.value == opportunitySurveyData?.BandwidthType)?.label == "Site-Level: Dedicated Bandwidth" ||
                      getBandwidthTypeOptions?.find((data) => data.value == opportunitySurveyData?.BandwidthType)?.label == "Site-Level: Broadband") && (
                        <div className="input-box form-floating">
                          <input
                            type="number"
                            placeholder="Required Bandwidth (in Mbps)"
                            className="form-control input-text form-control-sm mt-1"
                            id="RequiredBandwidthinMbps"
                            name="RequiredBandwidthinMbps"
                            value={opportunitySurveyData.RequiredBandwidthinMbps || ""}
                            onChange={formInputData}
                          />
                          <label htmlFor="RequiredBandwidthinMbps" className='mt-2'>Required Bandwidth (in Mbps)*</label>
                        </div>
                      )}

                    {/* <div className="">
                                 <label className="select-search-label mt-1">
                                   Count of Existing Internet Links
                                 </label>
                                 <Select
                                   className="basic-single form-control form-control-sm p-1"
                                   classNamePrefix="select"
                                   id="CountOfExistingInternetLinks"
                                   name="Countofexistinginternetlinks"
                                   placeholder="Select Count"
                                   styles={style}
                                   // value={selectedDropdownObj?.CountOfExistingInternetLinks}
                                   value={getCountOfExistingInternetLinksOptions?.find((data) => data.value == opportunitySurveyData?.Countofexistinginternetlinks)}
                                   onChange={(selectedOption) => formDropdownInput("Countofexistinginternetlinks", selectedOption?.value)}
                                   options={getCountOfExistingInternetLinksOptions}
                                 />
                               </div> */}

                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder="ISP of existing internet Link 1"
                        className="form-control input-text form-control-sm mt-1"
                        id="ISPofexistinginternetLink1"
                        name="ISPofexistinginternetLink1"
                        value={opportunitySurveyData.ISPofexistinginternetLink1 || ""}
                        onChange={formInputData}
                      />
                      <label htmlFor="ISPofexistinginternetLink1" className="mt-2">ISP of Existing Internet Link 1</label>
                    </div>

                    <div className="">
                      <label className="select-search-label mt-1">
                        Separate Network for Back-office Network?
                      </label>
                      <Select
                        className="basic-single form-control form-control-sm p-1"
                        classNamePrefix="select"
                        id="SeparateBackOfficeNetwork"
                        name="SeparateBackOfficeNetwork"
                        placeholder="Select Separate Network"
                        styles={style}
                        value={getSeparateNetworkForBackOfficeOptions?.find((data) => data.value == opportunitySurveyData?.SeparatenetworkBackoffice)}
                        onChange={(selectedOption) => formDropdownInput("SeparatenetworkBackoffice", selectedOption?.value)}
                        options={getSeparateNetworkForBackOfficeOptions}
                      />
                    </div>

                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder="Mobile Phone"
                        className="form-control input-text form-control-sm mt-1"
                        id="LinkTerminatingFloor"
                        name="LinkTerminatingFloor"
                        value={opportunitySurveyData.LinkTerminatingFloor || ""}
                        onChange={formInputData}
                      />
                      <label htmlFor="mobilephone" className='mt-2'>Link Terminating Floor*</label>
                    </div>


                    <div className="">
                      <label className="select-search-label mt-1">
                        Wired LAN Integration?
                      </label>
                      <Select
                        className="basic-single form-control form-control-sm p-1"
                        classNamePrefix="select"
                        id="WiredLANIntegration"
                        name="WiredLANIntegration"
                        placeholder="Select Wired LAN Integration"
                        styles={style}
                        value={getWiredLANIntegrationOptions?.find((data) => data.value == opportunitySurveyData?.WiredLANIntegration)}
                        onChange={(selectedOption) => formDropdownInput("WiredLANIntegration", selectedOption?.value)}
                        options={getWiredLANIntegrationOptions}
                      />
                    </div>

                    {(getWiredLANIntegrationOptions?.find((data) => data.value == opportunitySurveyData?.WiredLANIntegration))?.label == "Yes" && (
                      <>
                        <div className="input-box form-floating">
                          <input
                            type="number"
                            placeholder="Tentative count of devices"
                            className="form-control input-text form-control-sm mt-1"
                            id="NoofwiredLANports"
                            name="NoofwiredLANports"
                            value={opportunitySurveyData.NoofwiredLANports || ""}
                            onChange={formInputData}
                          />
                          <label htmlFor="TentativeDeviceCount" className="mt-2">No. of wired LAN ports</label>
                        </div>

                        <div className="">
                          <label className="select-search-label mt-1">
                            Type of Wired LAN Setup
                          </label>
                          <Select
                            className="basic-single form-control form-control-sm p-1"
                            classNamePrefix="select"
                            id="TypeofWiredLANSetup"
                            name="TypeofWiredLANSetup"
                            placeholder="Select IoT Devices Connection"
                            styles={style}
                            value={getTypeOfWiredLANSetupOptions?.find((data) => data.value == opportunitySurveyData?.TypeofWiredLANSetup || "")}
                            onChange={(selectedOption) => formDropdownInput("TypeofWiredLANSetup", selectedOption.value)}
                            options={getTypeOfWiredLANSetupOptions}
                          />
                        </div>
                      </>
                    )}

                    {opportunitySurveyData?.TypeofWiredLANSetup == "111260000" && (getWiredLANIntegrationOptions?.find((data) => data.value == opportunitySurveyData?.WiredLANIntegration))?.label == "Yes" && (
                      <>
                        <div className="input-box form-floating">
                          <input
                            type="text"
                            placeholder="Tentative count of devices"
                            className="form-control input-text form-control-sm mt-1"
                            id="MakeModelLANswitches"
                            name="MakeModelLANswitches"
                            value={opportunitySurveyData?.MakeModelLANswitches || ""}
                            onChange={formInputData}
                          />
                          <label htmlFor="MakeModelLANswitches" className="mt-2">Make/Model and number of existing LAN switches</label>
                        </div>

                      </>
                    )}

                    <div className="">
                      <label className="select-search-label mt-1">
                        Existing Wi-Fi Cabling by Customer?
                      </label>
                      <Select
                        className="basic-single form-control form-control-sm p-1"
                        classNamePrefix="select"
                        id="ExistingWiFiCabling"
                        name="ExistingWiFiCabling"
                        placeholder="Select Existing Wi-Fi Cabling"
                        styles={style}
                        value={getExistingWiFiCablingByCustomerOptions?.find((data) => data.value == opportunitySurveyData?.ExistingWiFiCabling)}
                        onChange={(selectedOption) => formDropdownInput("ExistingWiFiCabling", selectedOption?.value)}
                        options={getExistingWiFiCablingByCustomerOptions}
                      />
                    </div>


                    <div className="">
                      <label className="select-search-label mt-1">
                        API Integration Required?
                      </label>
                      <Select
                        className="basic-single form-control form-control-sm p-1"
                        classNamePrefix="select"
                        id="APIintegrationrequired"
                        name="APIintegrationrequired"
                        placeholder="Select API Integration"
                        styles={style}
                        value={getAPIIntegrationRequiredOptions?.find((data) => data.value == opportunitySurveyData?.APIintegrationrequired)}
                        // value={selectedDropdownObj?.APIIntegrationRequired}
                        onChange={(selectedOption) => formDropdownInput("APIintegrationrequired", selectedOption?.value)}
                        options={getAPIIntegrationRequiredOptions}
                      />
                    </div>


                    {opportunitySurveyData?.APIintegrationrequired == "111260000" && (
                      <div className="">
                        <label className="select-search-label mt-1">
                          PMS Vendor for API Integration?
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          id="PMSVendorforAPIIntegration"
                          name="PMSVendorforAPIIntegration"
                          placeholder="Select PMS Vendor"
                          styles={style}
                          // value={selectedDropdownObj?.PMSVendorForAPIIntegration}
                          value={getPMSVendorForAPIIntegrationOptions?.find((data) => data.value == opportunitySurveyData?.PMSVendorforAPIIntegration)}
                          onChange={(selectedOption) => formDropdownInput("PMSVendorforAPIIntegration", selectedOption?.value)}
                          options={getPMSVendorForAPIIntegrationOptions}
                        />
                      </div>
                    )}

                    <div className="">
                      <label className="select-search-label mt-1">
                        Any IoT Devices to be Connected?
                      </label>
                      <Select
                        className="basic-single form-control form-control-sm p-1"
                        classNamePrefix="select"
                        id="AnyIOTdevicestobeconnected"
                        name="AnyIOTdevicestobeconnected"
                        placeholder="Select IoT Devices Connection"
                        styles={style}
                        value={getAnyIOTDevicesToBeConnectedOptions?.find((data) => data.value == opportunitySurveyData?.AnyIOTdevicestobeconnected)}
                        onChange={(selectedOption) => formDropdownInput("AnyIOTdevicestobeconnected", selectedOption.value)}
                        options={getAnyIOTDevicesToBeConnectedOptions}
                      />
                    </div>

                    {opportunitySurveyData?.AnyIOTdevicestobeconnected == "111260000" && (
                      <div className="input-box form-floating">
                        <input
                          type="number"
                          placeholder="Tentative count of devices"
                          className="form-control input-text form-control-sm mt-1"
                          id="Tentativecountofdevices"
                          name="Tentativecountofdevices"
                          value={opportunitySurveyData.Tentativecountofdevices || ""}
                          onChange={formInputData}
                        />
                        <label htmlFor="TentativeDeviceCount" className="mt-2">Tentative Count of Devices</label>
                      </div>
                    )}

                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder="Special Request (if any)"
                        className="form-control input-text form-control-sm mt-1"
                        id="SpecialRequest"
                        name="SpecialRequest"
                        value={opportunitySurveyData.SpecialRequest || ""}
                        onChange={formInputData}
                      />
                      <label htmlFor="SpecialRequest" className="mt-2">Special Request (if any)</label>
                    </div>

                    <div className="mt-3 bg-body rounded mt-4 p-3" id="form7">
                      {/* Table Header with Plus Icon on Right */}
                      <div className="d-flex w-100 align-items-center mb-2">
                        <h6 className="mb-0 text-nowrap flex-grow-1">User licence grid:</h6>
                        <FaPlus
                          className="text-success"
                          type="button" data-bs-toggle="modal" data-bs-target="#exampleModal" data-bs-whatever="@mdo"
                          style={{ cursor: "pointer", fontSize: "1.0rem", marginRight: "5px" }}
                        // onClick={addRow}
                        />
                      </div>

                      {/* Bootstrap Table */}
                      <div className="table-responsive small">
                        <table className="table table-border table-sm table-striped small">
                          <thead className="table-secondary text-center small">
                            <tr>
                              <th>ID</th>
                              <th>User Type</th>
                              <th>No. of licences required </th>
                              <th>Speed Per User</th>
                              <th>Data Volume(in GB)</th>
                              <th>Plan Vilidity/Data Volume </th>
                              <th>Device per user</th>
                              <th>Login Machanism</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody className="text-center small">
                            {getUserlicencegridData?.length > 0 ? getUserlicencegridData.map((row, index) => (
                              <tr key={row.id} className="py-1">
                                <td>{index + 1}</td>
                                <td>{getUserTypeOptions.find((data) => data.value == row?.UserType).label}</td>
                                <td>{row.NoofUserLicensesrequired}</td>
                                <td>{getSpeedPerUserOptions.find((data) => data.value == row?.SpeedPerUser).label}</td>
                                <td>{row.DataVolumeinGB}</td>
                                <td>{row.DevicesperUser}</td>
                                <td>{getPlanValidityDataVolumeCriteriaOptions.find((data) => data.value == row?.PlanValidityDataVolumeCriteria).label}</td>
                                <td>{getLoginMechanismOptions.find((data) => data.value == row?.SpeedPerUser).label}</td>
                                <td>
                                  <FaEdit
                                    className="text-success mx-2"
                                    style={{ cursor: "pointer", fontSize: "0.9rem" }}
                                  // onClick={() => update(row.id)}
                                  />
                                  {/* <FaTrash
                                             className="text-danger"
                                             style={{ cursor: "pointer", fontSize: "0.9rem" }}
                                             // onClick={() => deleteRow(row.id)}
                                           /> */}
                                </td>
                              </tr>
                            )) :
                              <tr>
                                <td colSpan="10" className="text-center text-muted">
                                  No data found
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* ============ Model Grid Form ============= */}
                    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                      <div class="modal-dialog">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">New User Licence Grid</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                          </div>
                          <div class="modal-body">
                            <form>
                              <div class="mb-2">
                                <label for="recipient-name" class="col-form-label">User Type*</label>
                                <Select
                                  className="basic-single form-control form-control-sm p-1"
                                  classNamePrefix="select"
                                  placeholder="Select Option"
                                  name="dashboardReq"
                                  styles={style}
                                  value={userType}
                                  onChange={handleUserType}
                                  options={userTypeOption.map((data) => ({
                                    value: data.value,
                                    label: data.label,
                                  }))}
                                />
                              </div>
                              <div class="mb-2">
                                <label for="recipient-name" class="col-form-label">No. of User Licences Required*</label>
                                <input type="number"
                                  class="form-control"
                                  id="noUserLicences"
                                  name="noUserLicences"
                                  value={opportunityData.noUserLicences || ""}
                                  onChange={handleChange}
                                />
                              </div>
                              <div class="mb-2">
                                <label for="recipient-name" class="col-form-label">Speed Per User*</label>
                                <Select
                                  className="basic-single form-control form-control-sm p-1"
                                  classNamePrefix="select"
                                  placeholder="Select Option"
                                  name="dashboardReq"
                                  styles={style}
                                  value={speedPerUser}
                                  onChange={handleSpeedPerUser}
                                  options={speedPerUserOption.map((data) => ({
                                    value: data.value,
                                    label: data.label,
                                  }))}
                                />
                              </div>
                              <div class="mb-2">
                                <label for="recipient-name" class="col-form-label">Plan Validity/Data Volume Criteria*</label>
                                <Select
                                  className="basic-single form-control form-control-sm p-1"
                                  classNamePrefix="select"
                                  placeholder="Select Option"
                                  name="dashboardReq"
                                  styles={style}
                                  value={planValidity}
                                  onChange={handlePlanValidity}
                                  options={planValidityOption.map((data) => ({
                                    value: data.value,
                                    label: data.label,
                                  }))}
                                />
                              </div>

                              <div class="mb-2">
                                <label for="recipient-name" class="col-form-label">Data Valumn (in Gb)*</label>
                                <input type="number"
                                  class="form-control"
                                  id="dataValume"
                                  name="dataValume"
                                  value={opportunityData.dataValume || ""}
                                  onChange={handleChange}
                                />
                              </div>

                              <div class="mb-2">
                                <label for="recipient-name" class="col-form-label">Devices per User*</label>
                                <input type="number"
                                  class="form-control"
                                  id="devicesPerUser"
                                  name="devicesPerUser"
                                  value={opportunityData.devicesPerUser || ""}
                                  onChange={handleChange}
                                />
                              </div>

                              <div class="mb-2">
                                <label for="recipient-name" class="col-form-label">Login Mechanism*</label>
                                <Select
                                  className="basic-single form-control form-control-sm p-1"
                                  classNamePrefix="select"
                                  placeholder="Select Option"
                                  name="dashboardReq"
                                  styles={style}
                                  value={loginMechanism}
                                  onChange={handleLoginMechanism}
                                  options={loginMechanismOption.map((data) => ({
                                    value: data.value,
                                    label: data.label,
                                  }))}
                                />
                              </div>

                            </form>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="button" class="btn btn-primary" onClick={handleUserLicenceGrid}>Submit</button>
                          </div>
                        </div>
                      </div>
                    </div>

                  </fieldset>
                </div>

                {/* <div className="container shadow mb-3 bg-body rounded mt-4" id="form7" >
           <fieldset className="contact-form p-2">
             </fieldset>
             </div> */}
              </div>

            )}


            {(opportunityData?.ProductSegment == "Managed Wi-Fi Business-S" || opportunityData?.ProductSegment == "Managed Wi-Fi Business") && (
              <div
                className="Remarks-toggle mt-3"
                onClick={() => handleIconClick("SurveyTask")}
              >
                <span className="toggle-text">Survey Task</span>
                <span className=" float-end">
                  <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                </span>
              </div>
            )}

            {activeForm === "SurveyTask" && (
              <div
                className="container shadow mb-3 bg-body rounded mt-4"
                id="form7"
              >
                <div className="input-box form-floating p-3 select-search-label">
                  {getSurveyTaskData?.length > 0 && getSurveyTaskData[0]?.SurveyTaskID !== null ? getSurveyTaskData?.map((data, index) => (
                    <div className="mt-2" key={index}>
                      <strong>Survey Task ID: {data?.SurveyTaskID || "NA"}</strong>
                      <div>Contact Person Name: {data?.CustomerName || "NA"}</div>
                      <div>Created BY: {data?.CreatedBy || "NA"}</div>
                      <div>Status: <span style={{ color: data?.Status === "Open" ? "red" : data?.Status === "Approved" ? "green" : "black" }}>{data?.Status || "NA"}</span></div>
                    </div>
                  )) : <div>No Survey Task Found.</div>}
                </div>

              </div>)}

            {OppSubSeg !== "SDWAN" && (
              <>
                <div
                  className="Remarks-toggle mt-3"
                  onClick={() => handleIconClick("form6")}
                >
                  <span className="toggle-text">Feasibilty</span>
                  <span className=" float-end">
                    <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                  </span>
                </div>

                {activeForm === "form6" && (
                  <div
                    className="container shadow mb-3 bg-body rounded mt-4"
                    id="form6"
                  >
                    <div className="input-box form-floating p-3 select-search-label">
                      {getFeasibilityData?.length > 0 ? getFeasibilityData?.map((data, index) => (
                        <div className="input-box form-floating p-2" key={index}>
                          <strong className=''>Feasibility Id: {data?.FeasibilityId || ""}</strong>
                          <div>Route Type: {data?.RouteType ? "Redundant Route" : "Primary Route"}</div>
                          <div>Owner: {data?.Owner || "NA"}</div>
                          <div>Feasibilty Status: <span style={{ color: data?.FeasibilityStatus === "0" ? "red" : data?.FeasibilityStatus === "1" ? "green" : "black" }}> {data?.FeasibilityStatus == '1' ? 'Feasible' : '' || ""}</span></div>
                          <div>ARC: {data?.Arc || "NA"}</div>
                          <div>OTC: {data?.Otc || "NA"}</div>
                          <div>ISP Name: {data?.IspName || "NA"}</div>
                        </div>
                      )) : <div>No Feasibility records found.</div>}
                    </div>
                  </div>)}
              </>
            )}

          {opportunityData?.ProductSegment != "DIA" &&
            <div
              className="Remarks-toggle mt-3"
              onClick={() => handleIconClick("form7")}
            >
              <span className="toggle-text">Pre-sales Task</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>}


            {activeForm === "form7" && (
              <div
                className="container shadow mb-3 bg-body rounded mt-4"
                id="form7"
              >
                <div className="input-box form-floating p-3 select-search-label">
                  {getPreSalesTask?.length > 0 ? getPreSalesTask?.map((data, index) => (
                    <div className="mt-2" key={index}>
                      <strong>Pre-Sales Task Id: {data?.PresalesTaskID || "NA"}</strong>
                      <div>Contact Person Name: {data?.ContactPersonName || "NA"}</div>
                      <div>Meeting Done With Customer: {data?.MeetingDoneWithCustomer || "NA"}</div>
                      <div>Created BY: {data?.CreatedBY || "NA"}</div>
                      <div>Created On: {data?.CreatedOn || "NA"}</div>
                      <div>Status: <span style={{ color: data?.Status === "Open" ? "red" : data?.Status === "Approved" ? "green" : "black" }}>{data?.Status || "NA"}</span></div>
                    </div>
                  )) : <div>No Pre-Sales Task Found.</div>}
                </div>

              </div>)}


            <div
              className="Remarks-toggle mt-3"
              onClick={() => handleIconClick("form8")}
            >
              <span className="toggle-text">DOA Approvals</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>

            {activeForm === "form8" && (
              <div
                className="container shadow mb-3 bg-body rounded mt-4"
                id="form8"
              >
                <fieldset className="Remarks-form p-2">
                  <div className="input-box form-floating">
                    <div className="input-box form-floating p-3 select-search-label">
                      {getDoaApprovalData?.length > 0 ? getDoaApprovalData?.map((data, index) => (
                        <div className="input-box form-floating p-2" key={index}>
                          <strong>Name: {data?.Name || "NA"}</strong>
                          <div>Approval Requested Date: {data?.ApprovalRequestedDate || "NA"}</div>
                          <div>Approver: {data?.Approver || "NA"}</div>
                          <div>Status: {data?.Status || "NA"}</div>
                          <div>Status Reason: <span style={{ color: data?.StatusReason !== "Approved" ? "red" : data?.StatusReason == "Approved" ? "green" : "black" }}>{data?.StatusReason}</span></div>
                        </div>
                      )) : <div>No Approval records found.</div>}

                    </div>
                  </div>
                </fieldset>
              </div>)}


            {/* <div className="Remarks-toggle mt-3" onClick={redirectPriceCalPage}>
              <span className="toggle-text">Price Calculator</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div> */}

            {/* <div className="Remarks-toggle mt-3" onClick={() => handleIconClick("form13")}
            >
              <span className="toggle-text">Praposal Details</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div> */}


            {activeForm === "form13" && (
              <div className="container shadow mb-3 bg-body rounded mt-4" id="form13">
                <fieldset className="Remarks-form p-2">
                  <div className="Other-details-toggle mt-3">

                    <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                      {allPraposalData && allPraposalData?.length > 0 ? (
                        allPraposalData.map((data, index) => (
                          <div className="col" key={index}>
                            <div className="card mb-3">
                              <div className="m-3 card-data" style={{ display: "inline-flex" }} >
                                <div>
                                  {/* <p className="caf-card-text">Opportunity Id : {data.OpportunityID}</p>
                                  <p className="caf-card-text" style={{ textWrap: "nowrap" }}> Document Name : {data.ProposalDocName}</p> */}
                                  <p className="caf-card-text">Created On : {data.ProposalCreatedOn}</p>

                                </div>
                              </div>
                              <div className="d-flex justify-content-center gap-2 p-2">
                                <button type="button" className="btn qualify-btn text-light w-50" onClick={() => handleDownload(data)}>
                                  Download
                                </button>

                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="col-12 text-center">
                          <p>No data available.</p>
                        </div>
                      )}
                    </div>



                  </div>
                </fieldset>
              </div>
            )}




            {/* <div className="Remarks-toggle mt-3" onClick={() => handleIconClick("form11")}>
              <span className="toggle-text">Remarks</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div> */}

            {activeForm === "form11" && (
              <div className="container shadow mb-3 bg-body rounded mt-4" id="form11">
                <fieldset className="Remarks-form p-2">
                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className="form-control input-text form-control-sm mt-1"
                      id="Remarks"
                      name="Remarks"
                      value={opportunityData.Remarks || ""} onChange={handleChange} />
                    <label htmlFor="floatingInput" className="mt-2">Remarks</label>
                  </div>
                </fieldset>
              </div>)}

            {/* <div
            className="doc-toggle mt-3"
            // hidden={docHide}
            onClick={manageDocClickBusiness}
          >
            <span className="toggle-text">Documents</span>
            <span className="float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div> */}


            <div className=" text-center mt-5 mb-3">
              <button
                type="button"
                className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                onClick={handleUpdateOpportunity}
                disabled={opportunityData.Status == "Won"}
              >
                Update
              </button>
            </div>

          </div>
        </form>
      )}
    </>
  );
};

export default BusinessOpportunityForm;
